{
  " (provisional)": " (provisional)",
  " ({slot0})": " ({slot0})",
  " / {slot0}": " / {slot0}",
  " Building credits": " Building credits",
  " COMPOSITION COMPLETE": " COMPOSITION COMPLETE",
  " Edit & release settings": " Edit & release settings",
  " Follow latest": " Follow latest",
  " I can share these recordings and artwork under the selected licence.": " I can share these recordings and artwork under the selected licence.",
  " Loading…": " Loading…",
  " My releases and uploads": " My releases and uploads",
  " Pane widths": " Pane widths",
  " Projects": " Projects",
  " Publish": " Publish",
  " Reference images": " Reference images",
  " Review & publish": " Review & publish",
  " Review release settings": " Review release settings",
  " Send": " Send",
  " Settings & references": " Settings & references",
  " Terrain credits": " Terrain credits",
  " Undo": " Undo",
  " Your next match will use the default colony.": " Your next match will use the default colony.",
  " checks": " checks",
  " credits": " credits",
  " diverged": " diverged",
  " likes": " likes",
  " on {p0}": " on {p0}",
  " refused orders": " refused orders",
  " seconds": " seconds",
  " this version": " this version",
  " to confirm": " to confirm",
  " · ": " · ",
  " · Charged: ": " · Charged: ",
  " · Completed ": " · Completed ",
  " · Content hidden": " · Content hidden",
  " · hidden": " · hidden",
  " · incomplete historical data": " · incomplete historical data",
  " · stale": " · stale",
  " · updated ": " · updated ",
  " · {slot0}": " · {slot0}",
  " · {slot0} disconnect": {
    "one": " · {slot0} disconnect",
    "other": " · {slot0} disconnects"
  },
  " · {slot0} disconnects": " · {slot0} disconnects",
  " — ": " — ",
  " → ": " → ",
  "#{slot0}": "#{slot0}",
  "(match)": "(match)",
  ", and enter:": ", and enter:",
  ", or create an account below": ", or create an account below",
  ", so it cannot be added to the account you are playing as. Accounts are never merged.": ", so it cannot be added to the account you are playing as. Accounts are never merged.",
  ", then": ", then",
  ", to confirm": ", to confirm",
  ".": ".",
  ". You can close this page.": ". You can close this page.",
  "/ais/favourites": "/ais/favourites",
  "/ais/mine": "/ais/mine",
  "1.0.0": "1.0.0",
  "3 to 32 letters, digits, dots, dashes or underscores. Other players see it.": "3 to 32 letters, digits, dots, dashes or underscores. Other players see it.",
  "95%: {slot0}": "95%: {slot0}",
  ": ": ": ",
  ": create a room and invite your friends, or find a quick match.": ": create a room and invite your friends, or find a quick match.",
  "; nothing to install.": "; nothing to install.",
  "A Globulation 2 colony: globs at work around their swarm": "A Globulation 2 colony: globs at work around their swarm",
  "A JSON file with everything this server stores about your account: your profile, sign-in methods (without passwords or keys), matches, ratings, rooms and chat, matchmaking, maps and moderation records.": "A JSON file with everything this server stores about your account: your profile, sign-in methods (without passwords or keys), matches, ratings, rooms and chat, matchmaking, maps and moderation records.",
  "A SOUNDTRACK FOR YOUR COLONY": "A SOUNDTRACK FOR YOUR COLONY",
  "A colony takes shape": "A colony takes shape",
  "A dismissed report cannot hide content.": "A dismissed report cannot hide content.",
  "A generated room map needs params.teams between 1 and 12.": "A generated room map needs params.teams between 1 and 12.",
  "A hand-made map has no generator.": "A hand-made map has no generator.",
  "A hidden set cannot publish new releases.": "A hidden set cannot publish new releases.",
  "A map keeps at most {p0} versions; delete old ones first.": "A map keeps at most {p0} versions; delete old ones first.",
  "A new library is taking shape. Share the first AI.": "A new library is taking shape. Share the first AI.",
  "A new mind for your colony": "A new mind for your colony",
  "A newer draft prevents undo. Use history to restore it.": "A newer draft prevents undo. Use history to restore it.",
  "A newer revision prevents undo. Restore a version in Changes.": "A newer revision prevents undo. Restore a version in Changes.",
  "A previous submission was not acknowledged. Sending it again safely retries the same request.": "A previous submission was not acknowledged. Sending it again safely retries the same request.",
  "A recoverable active account is required for colony skins.": "A recoverable active account is required for colony skins.",
  "A registered account is required.": "A registered account is required.",
  "A release must retain its package ID.": "A release must retain its package ID.",
  "A saved request is ready to send again safely.": "A saved request is ready to send again safely.",
  "A world of possibilities": "A world of possibilities",
  "A · V{slot0}": "A · V{slot0}",
  "AI": "AI",
  "AI Building Studio": "AI Building Studio",
  "AI Building Studio is not enabled on this instance.": "AI Building Studio is not enabled on this instance.",
  "AI JavaScript source": "AI JavaScript source",
  "AI Library": "AI Library",
  "AI MAP STUDIO": "AI MAP STUDIO",
  "AI MUSIC STUDIO": "AI MUSIC STUDIO",
  "AI Map Studio": "AI Map Studio",
  "AI Map Studio is not enabled on this instance.": "AI Map Studio is not enabled on this instance.",
  "AI Map Studio is not enabled on this instance. Your saved projects remain available.": "AI Map Studio is not enabled on this instance. Your saved projects remain available.",
  "AI Music Studio": "AI Music Studio",
  "AI Music Studio is not enabled on this instance.": "AI Music Studio is not enabled on this instance.",
  "AI Music Studio is not enabled on this instance. Your saved projects remain available.": "AI Music Studio is not enabled on this instance. Your saved projects remain available.",
  "AI Studio": "AI Studio",
  "AI Terrain Studio": "AI Terrain Studio",
  "AI Terrain Studio is not enabled on this instance.": "AI Terrain Studio is not enabled on this instance.",
  "AI authoring resources": "AI authoring resources",
  "AI disclosure": "AI disclosure",
  "AI generated map": "AI generated map",
  "AI library views": "AI library views",
  "AI map versions are immutable. Create a revision in AI Map Studio or upload an edited copy as a new map.": "AI map versions are immutable. Create a revision in AI Map Studio or upload an edited copy as a new map.",
  "AI opponent · ratings and games belong to this game version": "AI opponent · ratings and games belong to this game version",
  "AI ratings belong to a game version. {slot0} to see older versions.": "AI ratings belong to a game version. {slot0} to see older versions.",
  "AI tags": "AI tags",
  "AI-generated": "AI-generated",
  "API {slot0}, toolkit {slot1}, suite {slot2}. These checks sample settings and do not certify balance.": "API {slot0}, toolkit {slot1}, suite {slot2}. These checks sample settings and do not certify balance.",
  "Abandoned": "Abandoned",
  "About": "About",
  "About & help": "About & help",
  "Accepted": "Accepted",
  "Account adjustment": "Account adjustment",
  "Account already in use": "Account already in use",
  "Account changes": "Account changes",
  "Account changes need review": "Account changes need review",
  "Account draft saved": "Account draft saved",
  "Account inactive.": "Account inactive.",
  "Account is unavailable.": "Account is unavailable.",
  "Acoustic · woodwinds, strings & folk": "Acoustic · woodwinds, strings & folk",
  "Across": "Across",
  "Action": "Action",
  "Active": "Active",
  "Active accounts": "Active accounts",
  "Activity comparison table": "Activity comparison table",
  "Activity trends": "Activity trends",
  "Actor account ID": "Actor account ID",
  "Actual game size · 1×": "Actual game size · 1×",
  "Add": "Add",
  "Add a property override": "Add a property override",
  "Add a terrain or resource to begin. Built-in presets supply properties without copying their artwork into your set.": "Add a terrain or resource to begin. Built-in presets supply properties without copying their artwork into your set.",
  "Add frames in order.": "Add frames in order.",
  "Add selected frame": "Add selected frame",
  "Add stage": "Add stage",
  "Add stock level": "Add stock level",
  "Add the base frame first.": "Add the base frame first.",
  "Add {slot0}": "Add {slot0}",
  "Additional credits and source attribution": "Additional credits and source attribution",
  "Additional field": "Additional field",
  "Address": "Address",
  "Administration": "Administration",
  "Administration sections": "Administration sections",
  "Administrator": "Administrator",
  "Administrator access is required.": "Administrator access is required.",
  "Administrator access required.": "Administrator access required.",
  "Advanced mixing": "Advanced mixing",
  "Advanced properties JSON": "Advanced properties JSON",
  "After payment, your balance updates once payment is confirmed. You can return to your colony while it is processed.": "After payment, your balance updates once payment is confirmed. You can return to your colony while it is processed.",
  "Agreed so far": "Agreed so far",
  "Air health change": "Air health change",
  "All": "All",
  "All candidate measurements": "All candidate measurements",
  "All compatibility checks must pass before publishing.": "All compatibility checks must pass before publishing.",
  "All downloads": "All downloads",
  "All engine versions": "All engine versions",
  "All generation attempts": "All generation attempts",
  "All generators": "All generators",
  "All libraries": "All libraries",
  "All licenses": "All licenses",
  "All matches": "All matches",
  "All music": "All music",
  "All open licences": "All open licences",
  "All properties and capabilities": "All properties and capabilities",
  "All rankings": "All rankings",
  "All sets": "All sets",
  "All-time library totals; this ranking does not change with the selected reporting range. Counts follow each library’s rules and do not represent unique people.": "All-time library totals; this ranking does not change with the selected reporting range. Counts follow each library’s rules and do not represent unique people.",
  "Allowed resource keys (null uses habitats)": "Allowed resource keys (null uses habitats)",
  "Already in the game? Choose": "Already in the game? Choose",
  "Always available": "Always available",
  "An account is required to publish publicly.": "An account is required to publish publicly.",
  "An available Building credit is needed to chat or build.": "An available Building credit is needed to chat or build.",
  "An available Terrain credit is needed to chat or build.": "An available Terrain credit is needed to chat or build.",
  "An available {value0} credit is needed.": "An available {value0} credit is needed.",
  "Analytics display is disabled.": "Analytics display is disabled.",
  "Animation phase": "Animation phase",
  "Another session saved revision {slot0}. Your local edits are preserved.": "Another session saved revision {slot0}. Your local edits are preserved.",
  "Another upload is in progress. Please retry shortly.": "Another upload is in progress. Please retry shortly.",
  "Any": "Any",
  "Any size": "Any size",
  "Any status": "Any status",
  "Any teams": "Any teams",
  "Anyone with the link": "Anyone with the link",
  "Appearance": "Appearance",
  "Applied": "Applied",
  "Applies to": "Applies to",
  "Apply soundtrack loudness targets and peak limiting": "Apply soundtrack loudness targets and peak limiting",
  "Apply to {slot0}": "Apply to {slot0}",
  "Artifact view": "Artifact view",
  "Artwork": "Artwork",
  "Artwork and font credits": "Artwork and font credits",
  "Artwork could not be prepared for some older devices. Those devices will use the default colony.": "Artwork could not be prepared for some older devices. Those devices will use the default colony.",
  "Artwork for some older devices is still preparing. Those devices may temporarily show the default colony.": "Artwork for some older devices is still preparing. Those devices may temporarily show the default colony.",
  "Assemble the family": "Assemble the family",
  "Assemble the pack": "Assemble the pack",
  "At least {p0} characters.": "At least {p0} characters.",
  "At least {p0} seats must be taken.": "At least {p0} seats must be taken.",
  "Attached diagnostics": "Attached diagnostics",
  "Attack power": "Attack power",
  "Attempts": "Attempts",
  "Audible comparison version": "Audible comparison version",
  "Audio quality checks": "Audio quality checks",
  "Audit history": "Audit history",
  "Authenticated account activity; anonymous visitors are excluded.": "Authenticated account activity; anonymous visitors are excluded.",
  "Author-reported generator": "Author-reported generator",
  "Authoring guide": "Authoring guide",
  "Authoring guide ↗": "Authoring guide ↗",
  "Average successful completion time": "Average successful completion time",
  "Awaiting provider outcome": "Awaiting provider outcome",
  "Awaiting validation": "Awaiting validation",
  "Back to Globulation 2": "Back to Globulation 2",
  "Back to My skins": "Back to My skins",
  "Back to sign in": "Back to sign in",
  "Back to the home page": "Back to the home page",
  "Background color": "Background color",
  "Background material": "Background material",
  "Background noise": "Background noise",
  "Balanced": "Balanced",
  "Ban": "Ban",
  "Ban {value0}? This signs them out everywhere.": "Ban {value0}? This signs them out everywhere.",
  "Band width": "Band width",
  "Banned": "Banned",
  "Base artwork": "Base artwork",
  "Behind": "Behind",
  "Best {slot0}": "Best {slot0}",
  "Both": "Both",
  "Boundary style": "Boundary style",
  "Branching spires rising from a mound.": "Branching spires rising from a mound.",
  "Broken": "Broken",
  "Browse": "Browse",
  "Browse library": "Browse library",
  "Browse maps": "Browse maps",
  "Browse the library": "Browse the library",
  "Browser recovery is unavailable. Keep this page open until changes are saved.": "Browser recovery is unavailable. Keep this page open until changes are saved.",
  "Brush": "Brush",
  "Brush and eraser reach hidden surfaces underneath the cursor. Some front/back and top/bottom surfaces share paint. A stroke may appear on their matching side too, keeping the glob’s flips seamless.": "Brush and eraser reach hidden surfaces underneath the cursor. Some front/back and top/bottom surfaces share paint. A stroke may appear on their matching side too, keeping the glob’s flips seamless.",
  "Brush paints": "Brush paints",
  "Brush size ": "Brush size ",
  "Build": "Build",
  "Build a consistent world with custom terrain, resources, and artwork.": "Build a consistent world with custom terrain, resources, and artwork.",
  "Build details": "Build details",
  "Build in AI Map Studio": "Build in AI Map Studio",
  "Build in AI Music Studio": "Build in AI Music Studio",
  "Build in AI Studio": "Build in AI Studio",
  "Build the playable map": "Build the playable map",
  "Build wooded hills with wide routes between colonies": "Build wooded hills with wide routes between colonies",
  "Building": "Building",
  "Building Studio": "Building Studio",
  "Building Studio is disabled on this instance. Your saved projects remain available.": "Building Studio is disabled on this instance. Your saved projects remain available.",
  "Building Studio is disabled.": "Building Studio is disabled.",
  "Building color": "Building color",
  "Building color preview": "Building color preview",
  "Building design conversation": "Building design conversation",
  "Building family": "Building family",
  "Building family editor": "Building family editor",
  "Building library": "Building library",
  "Building projects": "Building projects",
  "Building-credit sales are not enabled.": "Building-credit sales are not enabled.",
  "Buildings": "Buildings",
  "Buildings allowed": "Buildings allowed",
  "Buildings and upgrade stages": "Buildings and upgrade stages",
  "Buildings under construction": "Buildings under construction",
  "Buildings: latest verified match against recent average": "Buildings: latest verified match against recent average",
  "Bundled JavaScript file": "Bundled JavaScript file",
  "Buy {slot0}": "Buy {slot0}",
  "Buy {slot0} credit · {slot1}": {
    "one": "Buy {slot0} credit · {slot1}",
    "other": "Buy {slot0} credits · {slot1}"
  },
  "Buy {slot0} credits · {slot1}": "Buy {slot0} credits · {slot1}",
  "By a map generator": "By a map generator",
  "By generator": "By generator",
  "By map": "By map",
  "By queue": "By queue",
  "By {slot0}": "By {slot0}",
  "By {slot0} · {slot1} likes · {slot2}": "By {slot0} · {slot1} likes · {slot2}",
  "By {slot0} · {slot1} terrain · {slot2} resources": {
    "one": "By {slot0} · {slot1} terrain · {slot2} resources",
    "other": "By {slot0} · {slot1} terrains · {slot2} resources"
  },
  "By {slot0} · {slot1} terrains · {slot2} resources": "By {slot0} · {slot1} terrains · {slot2} resources",
  "By {slot0} · {slot1} · {slot2}": "By {slot0} · {slot1} · {slot2}",
  "B{slot0}": "B{slot0}",
  "CC BY": "CC BY",
  "CC BY 4.0": "CC BY 4.0",
  "CC BY 4.0 — credit required": "CC BY 4.0 — credit required",
  "CC BY-SA 4.0": "CC BY-SA 4.0",
  "CC-BY-4.0": "CC-BY-4.0",
  "CC-BY-SA-4.0": "CC-BY-SA-4.0",
  "CC0": "CC0",
  "CC0 1.0": "CC0 1.0",
  "CC0 — public domain": "CC0 — public domain",
  "CC0-1.0": "CC0-1.0",
  "CHOOSE FINAL VIEW": "CHOOSE FINAL VIEW",
  "COLONY STUDIO": "COLONY STUDIO",
  "COMMUNITY SOUNDTRACKS": "COMMUNITY SOUNDTRACKS",
  "COMMUNITY · LOCAL PLAY": "COMMUNITY · LOCAL PLAY",
  "CURRENT POSE": "CURRENT POSE",
  "Cabino": "Cabino",
  "Cache write tokens": "Cache write tokens",
  "Cached input": "Cached input",
  "Cached input tokens": "Cached input tokens",
  "Calm": "Calm",
  "Calm → Building → Combat → Calm · eight seconds per mood": "Calm → Building → Combat → Calm · eight seconds per mood",
  "Camera angle ": "Camera angle ",
  "Camera view": "Camera view",
  "Can be farmed": "Can be farmed",
  "Can be retried": "Can be retried",
  "Cancel": "Cancel",
  "Cancel editing": "Cancel editing",
  "Cancel generation": "Cancel generation",
  "Cancel report": "Cancel report",
  "Cancel request": "Cancel request",
  "Cancel upload": "Cancel upload",
  "Cancellation is unavailable while the provider outcome and reserved credits are reconciled. You can keep editing the saved source or export it.": "Cancellation is unavailable while the provider outcome and reserved credits are reconciled. You can keep editing the saved source or export it.",
  "Cancellation requested": "Cancellation requested",
  "Cancelled": "Cancelled",
  "Candidate preview · may need repairs": "Candidate preview · may need repairs",
  "Candidate previews & reports": "Candidate previews & reports",
  "Candidate unavailable.": "Candidate unavailable.",
  "Candidate {slot0}": "Candidate {slot0}",
  "Canonical package SHA-256: {slot0}": "Canonical package SHA-256: {slot0}",
  "Cash amount": "Cash amount",
  "Castor": "Castor",
  "Catalog": "Catalog",
  "Categorical": "Categorical",
  "Change": "Change",
  "Change role": "Change role",
  "Change shape ⌄": "Change shape ⌄",
  "Changes": "Changes",
  "Changing settings takes effect when you press Generate. One seed per preview.": "Changing settings takes effect when you press Generate. One seed per preview.",
  "Charged": "Charged",
  "Charts appear once the server has replayed the match.": "Charts appear once the server has replayed the match.",
  "Chat": "Chat",
  "Check & publish": "Check & publish",
  "Check again": "Check again",
  "Check payment": "Check payment",
  "Check the connection, then try again.": "Check the connection, then try again.",
  "Check the essentials": "Check the essentials",
  "Check the score": "Check the score",
  "Checker": "Checker",
  "Checking": "Checking",
  "Checking generator…": "Checking generator…",
  "Checking the map with the game.": "Checking the map with the game.",
  "Checking the map…": "Checking the map…",
  "Checking your AI… {value0} of {value1} checks passed.{value2}": "Checking your AI… {value0} of {value1} checks passed.{value2}",
  "Checking your set…": "Checking your set…",
  "Checking your world…": "Checking your world…",
  "Checkout could not be opened. Please try again.": "Checkout could not be opened. Please try again.",
  "Checkout does not match this purchase.": "Checkout does not match this purchase.",
  "Checkout failed.": "Checkout failed.",
  "Checkout is not available yet; retry this event.": "Checkout is not available yet; retry this event.",
  "Checkout returned. Check the payment below to confirm your purchase.": "Checkout returned. Check the payment below to confirm your purchase.",
  "Checkout was cancelled. Your project and draft are saved.": "Checkout was cancelled. Your project and draft are saved.",
  "Checks": "Checks",
  "Checks apply to the last saved revision. ": "Checks apply to the last saved revision. ",
  "Checks cover the listed settings and do not certify game balance.": "Checks cover the listed settings and do not certify game balance.",
  "Checks failed": "Checks failed",
  "Checks for {value0}": "Checks for {value0}",
  "Checks passed": "Checks passed",
  "Checks validate gameplay properties, image bounds, frame mappings and rendering using the game engine. They do not establish map balance.": "Checks validate gameplay properties, image bounds, frame mappings and rendering using the game engine. They do not establish map balance.",
  "Checks · {slot0}": "Checks · {slot0}",
  "Chevrons": "Chevrons",
  "Choose 7, 30 or 90 days.": "Choose 7, 30 or 90 days.",
  "Choose a JPEG, PNG or WebP photo.": "Choose a JPEG, PNG or WebP photo.",
  "Choose a PNG or WebP frame.": "Choose a PNG or WebP frame.",
  "Choose a PNG spritesheet.": "Choose a PNG spritesheet.",
  "Choose a PNG, JPEG or WebP up to 2048×2048.": "Choose a PNG, JPEG or WebP up to 2048×2048.",
  "Choose a building ZIP package.": "Choose a building ZIP package.",
  "Choose a draft or a released set.": "Choose a draft or a released set.",
  "Choose a family name.": "Choose a family name.",
  "Choose a file to begin.": "Choose a file to begin.",
  "Choose a local custom game or a multiplayer room with this map.": "Choose a local custom game or a multiplayer room with this map.",
  "Choose a map file first: a .map or .map.gz file from the game.": "Choose a map file first: a .map or .map.gz file from the game.",
  "Choose a map first.": "Choose a map first.",
  "Choose a nonempty JavaScript file without NUL bytes.": "Choose a nonempty JavaScript file without NUL bytes.",
  "Choose a nonempty JavaScript file.": "Choose a nonempty JavaScript file.",
  "Choose a nonempty portable generator package without NUL bytes.": "Choose a nonempty portable generator package without NUL bytes.",
  "Choose a password": "Choose a password",
  "Choose a password of at least {p0} characters.": "Choose a password of at least {p0} characters.",
  "Choose a photo no larger than 10 MiB.": "Choose a photo no larger than 10 MiB.",
  "Choose a photo no larger than 25 megapixels.": "Choose a photo no larger than 25 megapixels.",
  "Choose a saved version, then describe the changes in chat. The saved map remains in history.": "Choose a saved version, then describe the changes in chat. The saved map remains in history.",
  "Choose a skin": "Choose a skin",
  "Choose a skin name.": "Choose a skin name.",
  "Choose a sprite, frame, layer and current revision.": "Choose a sprite, frame, layer and current revision.",
  "Choose a still JPEG, PNG or WebP photo, at most 25 megapixels.": "Choose a still JPEG, PNG or WebP photo, at most 25 megapixels.",
  "Choose a still PNG or WebP frame no larger than 512 by 512.": "Choose a still PNG or WebP frame no larger than 512 by 512.",
  "Choose a still PNG or WebP frame.": "Choose a still PNG or WebP frame.",
  "Choose a still photo, not an animation.": "Choose a still photo, not an animation.",
  "Choose a username": "Choose a username",
  "Choose a validated release for the simulation version you play. Each download includes its artwork.": "Choose a validated release for the simulation version you play. Each download includes its artwork.",
  "Choose a version": "Choose a version",
  "Choose an AI.": "Choose an AI.",
  "Choose an existing report to resolve.": "Choose an existing report to resolve.",
  "Choose an updated file to try again.": "Choose an updated file to try again.",
  "Choose automatic or initials.": "Choose automatic or initials.",
  "Choose either an import or a library version.": "Choose either an import or a library version.",
  "Choose final view": "Choose final view",
  "Choose how to sign in to the game:": "Choose how to sign in to the game:",
  "Choose one bundled .js file.": "Choose one bundled .js file.",
  "Choose profile photo": "Choose profile photo",
  "Choose property…": "Choose property…",
  "Choose revision": "Choose revision",
  "Choose sheet…": "Choose sheet…",
  "Choose the current draft revision.": "Choose the current draft revision.",
  "Choose up to five tags. These describe your strategy, not a tested strength rating.": "Choose up to five tags. These describe your strategy, not a tested strength rating.",
  "Choose uploaded sheet…": "Choose uploaded sheet…",
  "Choose visibility and a moderation reason.": "Choose visibility and a moderation reason.",
  "Choose {value0}": "Choose {value0}",
  "Clear selection": "Clear selection",
  "Close": "Close",
  "Close credits": "Close credits",
  "Close navigation": "Close navigation",
  "Close panel": "Close panel",
  "Close panel · Escape": "Close panel · Escape",
  "Close play choices": "Close play choices",
  "Close preview": "Close preview",
  "Close {value0}": "Close {value0}",
  "Closed": "Closed",
  "Code": "Code",
  "Code or invite link": "Code or invite link",
  "Collection disabled": "Collection disabled",
  "Collection enabled": "Collection enabled",
  "Colonies": "Colonies",
  "Colony AI": "Colony AI",
  "Colony skins": "Colony skins",
  "Colony still standing": "Colony still standing",
  "Colony {slot0}": "Colony {slot0}",
  "Colony {value0} paint": "Colony {value0} paint",
  "Colony {value0} skin": "Colony {value0} skin",
  "Color": "Color",
  "Colors your buildings; painted units stay unchanged.": "Colors your buildings; painted units stay unchanged.",
  "Colors, seams and raised decor": "Colors, seams and raised decor",
  "Combat": "Combat",
  "Commander account": "Commander account",
  "Commander work": "Commander work",
  "Community": "Community",
  "Community-made JavaScript players control a colony through Glob2’s AI API. Download a version, import it in Settings → Custom AIs, then choose it for a computer seat in a local game. Installed versions work offline; saved games keep their original code.": "Community-made JavaScript players control a colony through Glob2’s AI API. Download a version, import it in Settings → Custom AIs, then choose it for a computer seat in a local game. Installed versions work offline; saved games keep their original code.",
  "Compare revision": "Compare revision",
  "Compare with": "Compare with",
  "Compare with version": "Compare with version",
  "Compared revision": "Compared revision",
  "Compared revision {slot0}": "Compared revision {slot0}",
  "Compared revision: {slot0}": "Compared revision: {slot0}",
  "Compare…": "Compare…",
  "Compatibility checklist": "Compatibility checklist",
  "Compatibility checks": "Compatibility checks",
  "Compatibility checks exercise short games and save/resume. They do not certify safety or playing strength. Only run code from authors you trust.": "Compatibility checks exercise short games and save/resume. They do not certify safety or playing strength. Only run code from authors you trust.",
  "Compatibility of your active skin": "Compatibility of your active skin",
  "Complete": "Complete",
  "Complete family JSON": "Complete family JSON",
  "Complete passing checks before publishing.": "Complete passing checks before publishing.",
  "Completed": "Completed",
  "Completion time comparison table": "Completion time comparison table",
  "Compose the music": "Compose the music",
  "Composer’s progress": "Composer’s progress",
  "Composition": "Composition",
  "Configure Hive Mind in Settings → Online. In a match, press Ctrl+Enter to give an order. Assistance is permitted in ranked matches.": "Configure Hive Mind in Settings → Online. In a match, press Ctrl+Enter to give an order. Assistance is permitted in ranked matches.",
  "Confirm history deletion": "Confirm history deletion",
  "Confirm the license chosen when composing this version.": "Confirm the license chosen when composing this version.",
  "Confirmed cash": "Confirmed cash",
  "Confirmed cash table": "Confirmed cash table",
  "Confirmed cash uses Stripe charge/refund currency units; current and previous UTC periods. CSV exports preserve exact integer minor units.": "Confirmed cash uses Stripe charge/refund currency units; current and previous UTC periods. CSV exports preserve exact integer minor units.",
  "Confirming your payment. Your credits appear once payment is confirmed.": "Confirming your payment. Your credits appear once payment is confirmed.",
  "Connected": "Connected",
  "Connection": "Connection",
  "Connection interrupted. Reconnecting to your saved project…": "Connection interrupted. Reconnecting to your saved project…",
  "Connection quality per player": "Connection quality per player",
  "Consistent levels": "Consistent levels",
  "Content": "Content",
  "Content not found.": "Content not found.",
  "Contents": "Contents",
  "Contents & gameplay properties": "Contents & gameplay properties",
  "Continue as {p1}": "Continue as {p1}",
  "Continue to uploads": "Continue to uploads",
  "Continue to {p1}": "Continue to {p1}",
  "Continue with {p3}": "Continue with {p3}",
  "Controls and compatibility evidence": "Controls and compatibility evidence",
  "Conversation": "Conversation",
  "Convert and prepare preview": "Convert and prepare preview",
  "Converting": "Converting",
  "Copies the {slot0} texture and materials. Different models wrap that paint differently; inspect the results below.": "Copies the {slot0} texture and materials. Different models wrap that paint differently; inspect the results below.",
  "Copy paint": "Copy paint",
  "Copy paint to all models": "Copy paint to all models",
  "Copy paint to other models…": "Copy paint to other models…",
  "Copy recorded usage": "Copy recorded usage",
  "Copy this link into Family link or ID in the game’s Building families picker to open this family directly.": "Copy this link into Family link or ID in the game’s Building families picker to open this family directly.",
  "Copyright": "Copyright",
  "Correct the invalid JSON before saving.": "Correct the invalid JSON before saving.",
  "Cortex": "Cortex",
  "Could not check payment.": "Could not check payment.",
  "Could not crop this photo.": "Could not crop this photo.",
  "Could not delete this skin.": "Could not delete this skin.",
  "Could not load test map.": "Could not load test map.",
  "Could not load the material unwrap.": "Could not load the material unwrap.",
  "Could not load this language. Please try again.": "Could not load this language. Please try again.",
  "Could not load this model. Please retry.": "Could not load this model. Please retry.",
  "Could not load this {value0}": "Could not load this {value0}",
  "Could not load your project.": "Could not load your project.",
  "Could not load {value0}.{value1}": "Could not load {value0}.{value1}",
  "Could not open this photo.": "Could not open this photo.",
  "Could not save · retrying": "Could not save · retrying",
  "Could not send report.": "Could not send report.",
  "Could not update report.": "Could not update report.",
  "Could not use this skin.": "Could not use this skin.",
  "Count": "Count",
  "Cover": "Cover",
  "Create": "Create",
  "Create a building family": "Create a building family",
  "Create a building or an upgrade family with custom artwork.": "Create a building or an upgrade family with custom artwork.",
  "Create a colony AI through conversation.": "Create a colony AI through conversation.",
  "Create a family": "Create a family",
  "Create a fungal swamp with slow marsh, glowing wood trees, and renewable mushroom food.": "Create a fungal swamp with slow marsh, glowing wood trees, and renewable mushroom food.",
  "Create a look. Use it in your next match.": "Create a look. Use it in your next match.",
  "Create a map generator through conversation.": "Create a map generator through conversation.",
  "Create a mushroom hospital that heals workers and warriors, costs 10 wood, and holds four units.": "Create a mushroom hospital that heals workers and warriors, costs 10 wood, and holds four units.",
  "Create a new room with this map and invite friends.": "Create a new room with this map and invite friends.",
  "Create a ring of islands around a shared lagoon": "Create a ring of islands around a shared lagoon",
  "Create a set": "Create a set",
  "Create a winding river with room to grow": "Create a winding river with room to grow",
  "Create account": "Create account",
  "Create artwork": "Create artwork",
  "Create new release": "Create new release",
  "Create with AI": "Create with AI",
  "Create your own room": "Create your own room",
  "Created": "Created",
  "Created in {value0} Studio, revision {value1}": "Created in {value0} Studio, revision {value1}",
  "Creating accounts is turned off on this server.": "Creating accounts is turned off on this server.",
  "Creation needs attention.": "Creation needs attention.",
  "Creation ready.": "Creation ready.",
  "Creation workspace": "Creation workspace",
  "Creator credit": "Creator credit",
  "Credit activity": "Credit activity",
  "Credit flows and provider estimates include all recorded activity in this period, regardless of payment mode. Payment fees, hosting, exchange rates and profit are excluded.": "Credit flows and provider estimates include all recorded activity in this period, regardless of payment mode. Payment fees, hosting, exchange rates and profit are excluded.",
  "Credit purchase": "Credit purchase",
  "Credit purchases are currently unavailable.": "Credit purchases are currently unavailable.",
  "Credit purchases are not available on this instance.": "Credit purchases are not available on this instance.",
  "Credit purchases are not available.": "Credit purchases are not available.",
  "Credits": "Credits",
  "Credits & sources": "Credits & sources",
  "Credits pay for your commander’s thinking and follow-ups. Standing orders keep running when credits run out.": "Credits pay for your commander’s thinking and follow-ups. Standing orders keep running when credits run out.",
  "Crop": "Crop",
  "Crop selection": "Crop selection",
  "Crop your photo": "Crop your photo",
  "Cross-site request refused.": "Cross-site request refused.",
  "Crossfade to {value0}": "Crossfade to {value0}",
  "Currency": "Currency",
  "Current AI JavaScript source": "Current AI JavaScript source",
  "Current custom terrain and resource sprites rendered by the game": "Current custom terrain and resource sprites rendered by the game",
  "Current mean": "Current mean",
  "Current recorded": "Current recorded",
  "Current samples": "Current samples",
  "Current saved draft": "Current saved draft",
  "Current {slot0} day and previous {slot1} days. Activity totals count account-days; the active-account cards count distinct accounts. Studio/job statuses use request creation dates. Publications count versions; recorded downloads use each library’s existing counting rules.": {
    "one": "Current and previous reporting periods, in days: {slot0} and {slot1}. Activity totals count account-days; the active-account cards count distinct accounts. Studio/job statuses use request creation dates. Publications count versions; recorded downloads use each library’s existing counting rules.",
    "other": "Current and previous reporting periods, in days: {slot0} and {slot1}. Activity totals count account-days; the active-account cards count distinct accounts. Studio/job statuses use request creation dates. Publications count versions; recorded downloads use each library’s existing counting rules."
  },
  "Current {slot0} days and previous {slot1} days. Activity totals count account-days; the active-account cards count distinct accounts. Studio/job statuses use request creation dates. Publications count versions; recorded downloads use each library’s existing counting rules.": "Current {slot0} days and previous {slot1} days. Activity totals count account-days; the active-account cards count distinct accounts. Studio/job statuses use request creation dates. Publications count versions; recorded downloads use each library’s existing counting rules.",
  "Current: {slot0} through {slot1} (UTC; today is partial). Previous: {slot2} through {slot3}. Historical coverage may differ between periods.": "Current: {slot0} through {slot1} (UTC; today is partial). Previous: {slot2} through {slot3}. Historical coverage may differ between periods.",
  "Custom content credits": "Custom content credits",
  "Custom map": "Custom map",
  "Custom mood blend": "Custom mood blend",
  "Customize": "Customize",
  "Daily active accounts": "Daily active accounts",
  "Daily activity table": "Daily activity table",
  "Daily values": "Daily values",
  "Default colony": "Default colony",
  "Defence power": "Defence power",
  "Degraded": "Degraded",
  "Delayed orders": "Delayed orders",
  "Delete": "Delete",
  "Delete AI": "Delete AI",
  "Delete account": "Delete account",
  "Delete conversation history": "Delete conversation history",
  "Delete draft": "Delete draft",
  "Delete history permanently": "Delete history permanently",
  "Delete map": "Delete map",
  "Delete my account": "Delete my account",
  "Delete my account for good": "Delete my account for good",
  "Delete private release": "Delete private release",
  "Delete project": "Delete project",
  "Delete project history": "Delete project history",
  "Delete skin": "Delete skin",
  "Delete skin?": "Delete skin?",
  "Delete this project’s conversation, references and generated revisions permanently?": "Delete this project’s conversation, references and generated revisions permanently?",
  "Delete {slot0}?{slot1}": "Delete {slot0}?{slot1}",
  "Delete “{value0}” and all its versions?": "Delete “{value0}” and all its versions?",
  "Deleted": "Deleted",
  "Deletes sign-in identities, sessions, personal information and owned content. Match history remains anonymized. This cannot be undone.": "Deletes sign-in identities, sessions, personal information and owned content. Match history remains anonymized. This cannot be undone.",
  "Delivered": "Delivered",
  "Delivered map": "Delivered map",
  "Dense": "Dense",
  "Density": "Density",
  "Describe a building. Create its artwork and the way it works.": "Describe a building. Create its artwork and the way it works.",
  "Describe a change or ask a question": "Describe a change or ask a question",
  "Describe a map to build, ask a question, or explore an idea together.": "Describe a map to build, ask a question, or explore an idea together.",
  "Describe a world. Create its terrain and resources.": "Describe a world. Create its terrain and resources.",
  "Describe what your building should do and how it should look. You can also brainstorm before creating it.": "Describe what your building should do and how it should look. You can also brainstorm before creating it.",
  "Describe your creation or ask a question": "Describe your creation or ask a question",
  "Describe your idea, request a creation, or ask a question. Your project and its history stay private until you publish.": "Describe your idea, request a creation, or ask a question. Your project and its history stay private until you publish.",
  "Describe your landscape, or dream up a change…": "Describe your landscape, or dream up a change…",
  "Describe your map or discuss changes": "Describe your map or discuss changes",
  "Description": "Description",
  "Design": "Design",
  "Design brief {slot0}": "Design brief {slot0}",
  "Design conversation": "Design conversation",
  "Design the building": "Design the building",
  "Design the set": "Design the set",
  "Designer reply awaiting reconciliation": "Designer reply awaiting reconciliation",
  "Designer request failed": "Designer request failed",
  "Designer request status": "Designer request status",
  "Designer status": "Designer status",
  "Destination: {slot0} library. Run checks before publication.": "Destination: {slot0} library. Run checks before publication.",
  "Detailed usage rates": "Detailed usage rates",
  "Details": "Details",
  "Development credits": "Development credits",
  "Dimension": "Dimension",
  "Disable": "Disable",
  "Disable skin and resolve": "Disable skin and resolve",
  "Disabled": "Disabled",
  "Discard local retry": "Discard local retry",
  "Discard manual edits and load saved revision": "Discard manual edits and load saved revision",
  "Disconnected": "Disconnected",
  "Disconnects": "Disconnects",
  "Discover": "Discover",
  "Discover a new opponent. Find a new way to play.": "Discover a new opponent. Find a new way to play.",
  "Discussion spends no credits; 1 available Building credit is required. Creation and edit requests start automatically and cost 1 credit on delivery.": "Discussion spends no credits; 1 available Building credit is required. Creation and edit requests start automatically and cost 1 credit on delivery.",
  "Dismiss": "Dismiss",
  "Dismiss notification": "Dismiss notification",
  "Dismiss report": "Dismiss report",
  "Dismissed": "Dismissed",
  "Display names are at most {p0} bytes.": "Display names are at most {p0} bytes.",
  "Display names can only be changed once per interval.": "Display names can only be changed once per interval.",
  "Display names cannot contain control characters.": "Display names cannot contain control characters.",
  "Display names cannot start or end with spaces.": "Display names cannot start or end with spaces.",
  "Diverged": "Diverged",
  "Download": "Download",
  "Download JavaScript (.js)": "Download JavaScript (.js)",
  "Download SHA-256: {slot0}": "Download SHA-256: {slot0}",
  "Download ZIP": "Download ZIP",
  "Download candidate": "Download candidate",
  "Download exact package": "Download exact package",
  "Download family": "Download family",
  "Download local changes": "Download local changes",
  "Download local edits": "Download local edits",
  "Download my data": "Download my data",
  "Download progress": "Download progress",
  "Download replay": "Download replay",
  "Download saved draft": "Download saved draft",
  "Download selected": "Download selected",
  "Download set": "Download set",
  "Download the game": "Download the game",
  "Download this release": "Download this release",
  "Download {slot0}": "Download {slot0}",
  "Downloading replay…": "Downloading replay…",
  "Downloading the game…": "Downloading the game…",
  "Downloads": "Downloads",
  "Download{slot0}": "Download{slot0}",
  "Draft": "Draft",
  "Draft identities cannot change.": "Draft identities cannot change.",
  "Draft is temporarily empty. Add source to save.": "Draft is temporarily empty. Add source to save.",
  "Draft not found.": "Draft not found.",
  "Draft recovery failed": "Draft recovery failed",
  "Draft recovery failed.": "Draft recovery failed.",
  "Draft saved": "Draft saved",
  "Draft saved.": "Draft saved.",
  "Drafts": "Drafts",
  "Drafts are private. Publish a saved family to share it in the {slot0}.": "Drafts are private. Publish a saved family to share it in the {slot0}.",
  "Drag or use arrow keys to explore the wraparound map.": "Drag or use arrow keys to explore the wraparound map.",
  "Drag the playhead to explore": "Drag the playhead to explore",
  "Drag to choose your {slot0} angle": "Drag to choose your {slot0} angle",
  "Drag to explore when zoomed": "Drag to explore when zoomed",
  "Drag to paint · Rotate tool to turn · scroll or pinch to zoom": "Drag to paint · Rotate tool to turn · scroll or pinch to zoom",
  "Drag to position. Use arrow keys to move and the slider to zoom.": "Drag to position. Use arrow keys to move and the slider to zoom.",
  "Drag to rotate and tilt · scroll or pinch to zoom": "Drag to rotate and tilt · scroll or pinch to zoom",
  "Drag to turn · fixed height and scale": "Drag to turn · fixed height and scale",
  "Draw": "Draw",
  "Duplicate": "Duplicate",
  "Duplicate rig clip": "Duplicate rig clip",
  "Duplicate shape clip": "Duplicate shape clip",
  "Duration (steps)": "Duration (steps)",
  "Each point is a recorded UTC day. Gaps have no recorded measurement and are not interpolated or treated as zero. Hover or touch a point for its value; the daily table below provides the same values.": "Each point is a recorded UTC day. Gaps have no recorded measurement and are not interpolated or treated as zero. Hover or touch a point for its value; the daily table below provides the same values.",
  "Each product has its own credit unit. Flows cover the current selected range across all payment modes. Usage/refund ledger entries are signed; reserved balances are current snapshots.": "Each product has its own credit unit. Flows cover the current selected range across all payment modes. Usage/refund ledger entries are signed; reserved balances are current snapshots.",
  "Each shape shares the swarm paint area. Check the result after switching.": "Each shape shares the swarm paint area. Check the result after switching.",
  "Econo": "Econo",
  "Economy against each player’s average": "Economy against each player’s average",
  "Economy {slot0}": "Economy {slot0}",
  "Edit": "Edit",
  "Edit AI details": "Edit AI details",
  "Edit details": "Edit details",
  "Edit in AI Studio": "Edit in AI Studio",
  "Edit in Generator Studio": "Edit in Generator Studio",
  "Edit this saved draft": "Edit this saved draft",
  "Edit this version": "Edit this version",
  "Edit this version in chat": "Edit this version in chat",
  "Edit with AI": "Edit with AI",
  "Edit your map": "Edit your map",
  "Edit your soundtrack": "Edit your soundtrack",
  "Edit {value0}": "Edit {value0}",
  "Editing current saved draft · {slot0}": "Editing current saved draft · {slot0}",
  "Editing version {value0}": "Editing version {value0}",
  "Editing {slot0}": "Editing {slot0}",
  "Editor tool": "Editor tool",
  "Editor tools": "Editor tools",
  "Editor-only terrain cannot launch a colony game.": "Editor-only terrain cannot launch a colony game.",
  "Empty the seat before locking it.": "Empty the seat before locking it.",
  "Empty the seat before putting an AI in it.": "Empty the seat before putting an AI in it.",
  "Ended": "Ended",
  "Engine agent key required.": "Engine agent key required.",
  "Engine agents": "Engine agents",
  "Engine jobs": "Engine jobs",
  "Engine launch timed out. Stop and retry the preview.": "Engine launch timed out. Stop and retry the preview.",
  "Engine version": "Engine version",
  "Engine {slot0} · suite {slot1}": "Engine {slot0} · suite {slot1}",
  "Engine {slot0} · {slot1}": "Engine {slot0} · {slot1}",
  "Enlarged 3×": "Enlarged 3×",
  "Enter a JSON array.": "Enter a JSON array.",
  "Enter a username.": "Enter a username.",
  "Enter to send · Shift + Enter for a new line": "Enter to send · Shift + Enter for a new line",
  "Enter to send · Shift + Enter for a new line. Creation requests build automatically · 1 credit on delivery.": "Enter to send · Shift + Enter for a new line. Creation requests build automatically · 1 credit on delivery.",
  "Enter valid JSON.": "Enter valid JSON.",
  "Enter your password.": "Enter your password.",
  "Eraser": "Eraser",
  "Error": "Error",
  "Estimated provider costs": "Estimated provider costs",
  "Estimates use measured usage and configured, versioned monetary rates. Missing usage/pricing remains unavailable. An estimate covers priced attempts only; it is a partial subtotal whenever any attempt has unavailable cost.": "Estimates use measured usage and configured, versioned monetary rates. Missing usage/pricing remains unavailable. An estimate covers priced attempts only; it is a partial subtotal whenever any attempt has unavailable cost.",
  "Event": "Event",
  "Every member needs generator sharing support.": "Every member needs generator sharing support.",
  "Every room member must update before using a shared generator.": "Every room member must update before using a shared generator.",
  "Every seated player must be ready.": "Every seated player must be ready.",
  "Example generation settings": "Example generation settings",
  "Explore custom blends and fades. Restore game settings for the in-game transition.": "Explore custom blends and fades. Restore game settings for the in-game transition.",
  "Explore player and AI profiles": "Explore player and AI profiles",
  "Explore ratings and games": "Explore ratings and games",
  "Explorers": "Explorers",
  "Export activity CSV": "Export activity CSV",
  "Export cash CSV": "Export cash CSV",
  "Export credits CSV": "Export credits CSV",
  "Export provider costs CSV": "Export provider costs CSV",
  "Export saved package": "Export saved package",
  "Export viewed revision": "Export viewed revision",
  "Eyedropper": "Eyedropper",
  "FINAL VIEW": "FINAL VIEW",
  "Fade duration: ": "Fade duration: ",
  "Failed": "Failed",
  "Family experiments": "Family experiments",
  "Family experiments JSON": "Family experiments JSON",
  "Family link": "Family link",
  "Family name": "Family name",
  "Favourite": "Favourite",
  "Favourite AIs": "Favourite AIs",
  "Favourite an AI to keep it close.": "Favourite an AI to keep it close.",
  "Favourited": "Favourited",
  "Favourites": "Favourites",
  "Fields": "Fields",
  "File": "File",
  "File unavailable.": "File unavailable.",
  "Fills repeat across the model’s matching surfaces.": "Fills repeat across the model’s matching surfaces.",
  "Filter": "Filter",
  "Final game view · {slot0}°": "Final game view · {slot0}°",
  "Final statistics": "Final statistics",
  "Find a player": "Find a player",
  "Find content": "Find content",
  "Finding players…": "Finding players…",
  "Finish or cancel an existing upload first (maximum three active uploads).": "Finish or cancel an existing upload first (maximum three active uploads).",
  "Finished": "Finished",
  "Finished buildings": "Finished buildings",
  "Finished: {value0}": "Finished: {value0}",
  "First page": "First page",
  "Fit": "Fit",
  "Fit model": "Fit model",
  "Fit model · F": "Fit model · F",
  "Fitted {value0} unavailable, using the baked clip:": "Fitted {value0} unavailable, using the baked clip:",
  "Fix the failed checks and choose your updated file.": "Fix the failed checks and choose your updated file.",
  "Flow": "Flow",
  "Follow latest": "Follow latest",
  "Follow progress on the canvas.": "Follow progress on the canvas.",
  "Follow the composition, hear each candidate, and see what the checks find.": "Follow the composition, hear each candidate, and see what the checks find.",
  "Food in inns": "Food in inns",
  "Footprint height (tiles)": "Footprint height (tiles)",
  "For an unlisted family, copy its page link and paste it into Family link or ID in the game’s Building families picker, then choose Open family. Use the same online instance where the family was published. Private families also require signing in as their owner.": "For an unlisted family, copy its page link and paste it into Family link or ID in the game’s Building families picker, then choose Open family. Use the same online instance where the family was published. Private families also require signing in as their owner.",
  "Force re-verification": "Force re-verification",
  "Force re-verification of {value0}?": "Force re-verification of {value0}?",
  "Fork into Studio": "Fork into Studio",
  "Frame": "Frame",
  "Frame dimensions must be whole numbers between 1 and 64.": "Frame dimensions must be whole numbers between 1 and 64.",
  "Frame height": "Frame height",
  "Frame width": "Frame width",
  "Frames run left to right, then top to bottom.": "Frames run left to right, then top to bottom.",
  "Friends share a code or a link from their room.": "Friends share a code or a link from their room.",
  "From (UTC)": "From (UTC)",
  "From this view": "From this view",
  "Full compatibility key: {slot0}": "Full compatibility key: {slot0}",
  "Full definition and frame mappings": "Full definition and frame mappings",
  "Full leaderboard": "Full leaderboard",
  "Game preview": "Game preview",
  "Game scale": "Game scale",
  "Game version": "Game version",
  "Game versions": "Game versions",
  "Game-engine preview of the checked set": "Game-engine preview of the checked set",
  "Game-size reference": "Game-size reference",
  "Gameplay preset": "Gameplay preset",
  "Gameplay preset: {slot0}": "Gameplay preset: {slot0}",
  "Games": "Games",
  "Generate": "Generate",
  "Generate a map to inspect its terrain and starting colonies, then watch AI colonies play.": "Generate a map to inspect its terrain and starting colonies, then watch AI colonies play.",
  "Generate new landscapes from community JavaScript packages. Install a release in Settings → Map generators, or select it in an online room.": "Generate new landscapes from community JavaScript packages. Install a release in Settings → Map generators, or select it in an online room.",
  "Generated": "Generated",
  "Generated by": "Generated by",
  "Generated edits applied to revision {slot0}.": "Generated edits applied to revision {slot0}.",
  "Generated example map": "Generated example map",
  "Generated layout": "Generated layout",
  "Generated revisions": "Generated revisions",
  "Generated source accepted as revision {slot0}. Run engine checks before publication.": "Generated source accepted as revision {slot0}. Run engine checks before publication.",
  "Generated version accepted as your current edit target.": "Generated version accepted as your current edit target.",
  "Generation history {slot0}": "Generation history {slot0}",
  "Generation is unavailable. Saved code, export and local tools remain accessible.": "Generation is unavailable. Saved code, export and local tools remain accessible.",
  "Generation report": "Generation report",
  "Generation stages": "Generation stages",
  "Generation stopped. Your failed generation credit is returned.": "Generation stopped. Your failed generation credit is returned.",
  "Generation {value0} · {value1}": "Generation {value0} · {value1}",
  "Generator": "Generator",
  "Generator JavaScript source": "Generator JavaScript source",
  "Generator Studio": "Generator Studio",
  "Generator Studio is disabled on this instance. Recover saved files through": "Generator Studio is disabled on this instance. Recover saved files through",
  "Generator Studio is not enabled on this instance.": "Generator Studio is not enabled on this instance.",
  "Generator control values (JSON)": "Generator control values (JSON)",
  "Generator manifest JSON": "Generator manifest JSON",
  "Generator preview revision {value0}": "Generator preview revision {value0}",
  "Generators": "Generators",
  "Give a bounded moderation reason without NUL characters.": "Give a bounded moderation reason without NUL characters.",
  "Give a bounded recovery reason.": "Give a bounded recovery reason.",
  "Give a moderation reason.": "Give a moderation reason.",
  "Give a reason and a valid content identifier.": "Give a reason and a valid content identifier.",
  "Give a reason.": "Give a reason.",
  "Give a report reason of at most 2000 characters.": "Give a report reason of at most 2000 characters.",
  "Give orders. Receive reports. Lead your colony.": "Give orders. Receive reports. Lead your colony.",
  "Give your colony controller a home. Every release keeps its own source and download history.": "Give your colony controller a home. Every release keeps its own source and download history.",
  "Globs": "Globs",
  "Globs (all)": "Globs (all)",
  "Globulation 2": "Globulation 2",
  "Globulation 2 Online website": "Globulation 2 Online website",
  "Globulation 2 is free software (GPL 3).": "Globulation 2 is free software (GPL 3).",
  "Go back to the game: it has signed you in. You can close this tab.": "Go back to the game: it has signed you in. You can close this tab.",
  "Go to the home page": "Go to the home page",
  "Go to {p1}": "Go to {p1}",
  "Go to {p6}": "Go to {p6}",
  "Got an invite code?": "Got an invite code?",
  "Got it": "Got it",
  "Grass": "Grass",
  "Gravatar when available, otherwise initials": "Gravatar when available, otherwise initials",
  "Ground": "Ground",
  "Ground health change": "Ground health change",
  "Ground movement": "Ground movement",
  "Growth rate": "Growth rate",
  "Guest": "Guest",
  "Guest accounts are disabled on this instance.": "Guest accounts are disabled on this instance.",
  "Guest accounts created": "Guest accounts created",
  "Guest active account-days": "Guest active account-days",
  "Guest player": "Guest player",
  "Guests are not ranked and keep no statistics. Their matches still appear below.": "Guests are not ranked and keep no statistics. Their matches still appear below.",
  "Guests get generated names; link a sign-in method to choose one.": "Guests get generated names; link a sign-in method to choose one.",
  "Guests: {slot0} today · {slot1} weekly · {slot2} monthly": "Guests: {slot0} today · {slot1} weekly · {slot2} monthly",
  "HTTP {value0}": "HTTP {value0}",
  "Hand-made": "Hand-made",
  "Hand-made or generated": "Hand-made or generated",
  "Hardness ": "Hardness ",
  "Health restored per tick": "Health restored per tick",
  "Hear it in the game": "Hear it in the game",
  "Height": "Height",
  "Hex": "Hex",
  "Hidden": "Hidden",
  "Hidden by a moderator": "Hidden by a moderator",
  "Hidden by a moderator: {slot0}": "Hidden by a moderator: {slot0}",
  "Hidden following community report.": "Hidden following community report.",
  "Hidden following moderator review": "Hidden following moderator review",
  "Hidden: {slot0}": "Hidden: {slot0}",
  "Hide": "Hide",
  "Hide family": "Hide family",
  "Hide provisional ratings": "Hide provisional ratings",
  "Hide release and resolve": "Hide release and resolve",
  "Hide set": "Hide set",
  "Hide set and resolve": "Hide set and resolve",
  "Historical amounts or payment modes are incomplete. {slot0} purchases have incomplete historical facts. Refund money is never inferred from reversed credits.": "Historical amounts or payment modes are incomplete. {slot0} purchases have incomplete historical facts. Refund money is never inferred from reversed credits.",
  "Historical coverage": "Historical coverage",
  "History": "History",
  "Hive": "Hive",
  "Hive Mind": "Hive Mind",
  "Hive Mind credits": "Hive Mind credits",
  "Hive Mind is not available on this instance.": "Hive Mind is not available on this instance.",
  "Hive Mind is not enabled on this instance.": "Hive Mind is not enabled on this instance.",
  "Home": "Home",
  "How AIs work {slot0}": "How AIs work {slot0}",
  "How would you like to play?": "How would you like to play?",
  "Hue": "Hue",
  "Human match participants": "Human match participants",
  "Humans": "Humans",
  "Hungry globs": "Hungry globs",
  "I checked these token counts against provider evidence, including any explicitly entered zeros.": "I checked these token counts against provider evidence, including any explicitly entered zeros.",
  "IN GAME · {slot0}": "IN GAME · {slot0}",
  "INTERMEDIATE IMAGE": "INTERMEDIATE IMAGE",
  "Image is missing from storage.": "Image is missing from storage.",
  "Image is too large.": "Image is too large.",
  "Image not found.": "Image not found.",
  "Image unavailable.": "Image unavailable.",
  "Import": "Import",
  "Import in Settings → Custom AIs to use in local games.": "Import in Settings → Custom AIs to use in local games.",
  "Import package": "Import package",
  "Import the downloaded JSON in Settings → Map generators. Online rooms use this exact release without requiring other players to install it.": "Import the downloaded JSON in Settings → Map generators. Online rooms use this exact release without requiring other players to install it.",
  "Imported release {slot0}.": "Imported release {slot0}.",
  "In match": "In match",
  "In the game, choose": "In the game, choose",
  "In the map editor": "In the map editor",
  "In use": "In use",
  "In use · changes not applied": "In use · changes not applied",
  "Inappropriate content": "Inappropriate content",
  "Incomplete music release.": "Incomplete music release.",
  "Increase the manifest revision for a new release.": "Increase the manifest revision for a new release.",
  "Individual moods": "Individual moods",
  "Information": "Information",
  "Initial health": "Initial health",
  "Initials only": "Initials only",
  "Inn capacity": "Inn capacity",
  "Input tokens": "Input tokens",
  "Input tokens (including cached)": "Input tokens (including cached)",
  "Inspect candidate": "Inspect candidate",
  "Inspect latest release": "Inspect latest release",
  "Inspect library content": "Inspect library content",
  "Inspect match verification": "Inspect match verification",
  "Inspect matches": "Inspect matches",
  "Inspect recovery details": "Inspect recovery details",
  "Inspect requesting account": "Inspect requesting account",
  "Inspect sheet": "Inspect sheet",
  "Inspect this version": "Inspect this version",
  "Inspect tracks": "Inspect tracks",
  "Inspect version ": "Inspect version ",
  "Inspect version {slot0} · {slot1}": "Inspect version {slot0} · {slot1}",
  "Inspected": "Inspected",
  "Inspecting": "Inspecting",
  "Inspection zoom": "Inspection zoom",
  "Install community AIs for local games. Versions work offline. Only run code from authors you trust.": "Install community AIs for local games. Versions work offline. Only run code from authors you trust.",
  "Installed preset artwork": "Installed preset artwork",
  "Integer rate: 196608 means one growth opportunity or probability one. Zero disables it.": "Integer rate: 196608 means one growth opportunity or probability one. Zero disables it.",
  "Internal server error.": "Internal server error.",
  "Into the fray": "Into the fray",
  "Invalid": "Invalid",
  "Invalid account cursor.": "Invalid account cursor.",
  "Invalid audit cursor.": "Invalid audit cursor.",
  "Invalid checkout destination": "Invalid checkout destination",
  "Invalid checkout destination.": "Invalid checkout destination.",
  "Invalid claimed generator provenance.": "Invalid claimed generator provenance.",
  "Invalid cursor.": "Invalid cursor.",
  "Invalid date.": "Invalid date.",
  "Invalid duration filter.": "Invalid duration filter.",
  "Invalid editor-only filter.": "Invalid editor-only filter.",
  "Invalid engine version.": "Invalid engine version.",
  "Invalid identifier.": "Invalid identifier.",
  "Invalid manifest JSON.": "Invalid manifest JSON.",
  "Invalid mapId.": "Invalid mapId.",
  "Invalid material map dimensions.": "Invalid material map dimensions.",
  "Invalid material map.": "Invalid material map.",
  "Invalid material unwrap coordinate.": "Invalid material unwrap coordinate.",
  "Invalid material unwrap dimensions.": "Invalid material unwrap dimensions.",
  "Invalid model camera": "Invalid model camera",
  "Invalid model dimensions": "Invalid model dimensions",
  "Invalid model geometry": "Invalid model geometry",
  "Invalid model size": "Invalid model size",
  "Invalid model transform": "Invalid model transform",
  "Invalid page cursor.": "Invalid page cursor.",
  "Invalid page size.": "Invalid page size.",
  "Invalid pagination cursor.": "Invalid pagination cursor.",
  "Invalid pagination.": "Invalid pagination.",
  "Invalid payment signature.": "Invalid payment signature.",
  "Invalid provider.": "Invalid provider.",
  "Invalid range or payment mode.": "Invalid range or payment mode.",
  "Invalid recovery reason.": "Invalid recovery reason.",
  "Invalid report cursor.": "Invalid report cursor.",
  "Invalid report identifier.": "Invalid report identifier.",
  "Invalid report status.": "Invalid report status.",
  "Invalid request body.": "Invalid request body.",
  "Invalid request identifier.": "Invalid request identifier.",
  "Invalid rig UV": "Invalid rig UV",
  "Invalid rig clip": "Invalid rig clip",
  "Invalid rig dimensions": "Invalid rig dimensions",
  "Invalid rig frame mapping": "Invalid rig frame mapping",
  "Invalid rig hierarchy": "Invalid rig hierarchy",
  "Invalid rig index": "Invalid rig index",
  "Invalid rig influence bone": "Invalid rig influence bone",
  "Invalid rig inverse bind": "Invalid rig inverse bind",
  "Invalid rig normal": "Invalid rig normal",
  "Invalid rig pose": "Invalid rig pose",
  "Invalid rig radius": "Invalid rig radius",
  "Invalid rig sample": "Invalid rig sample",
  "Invalid rig size": "Invalid rig size",
  "Invalid rig track dimensions": "Invalid rig track dimensions",
  "Invalid rig transform": "Invalid rig transform",
  "Invalid rig weights": "Invalid rig weights",
  "Invalid shape UV": "Invalid shape UV",
  "Invalid shape clip": "Invalid shape clip",
  "Invalid shape dimensions": "Invalid shape dimensions",
  "Invalid shape frame": "Invalid shape frame",
  "Invalid shape heading": "Invalid shape heading",
  "Invalid shape index": "Invalid shape index",
  "Invalid shape scale": "Invalid shape scale",
  "Invalid shape size": "Invalid shape size",
  "Invalid skin dimensions.": "Invalid skin dimensions.",
  "Invalid studio event cursor.": "Invalid studio event cursor.",
  "Invalid visibility.": "Invalid visibility.",
  "Invalid webhook signature.": "Invalid webhook signature.",
  "Invalid webhook.": "Invalid webhook.",
  "Invalid {value0} camera": "Invalid {value0} camera",
  "Invalid {value0} dimensions": "Invalid {value0} dimensions",
  "Invalid {value0} normal camera": "Invalid {value0} normal camera",
  "Invalid {value0} scalar": "Invalid {value0} scalar",
  "Invite not found": "Invite not found",
  "It copies someone else’s work": "It copies someone else’s work",
  "It is broken or unplayable": "It is broken or unplayable",
  "It is offensive": "It is offensive",
  "It may not be installed on this device. You can": "It may not be installed on this device. You can",
  "JSON": "JSON",
  "JSON controls require the set workspace.": "JSON controls require the set workspace.",
  "JSON value": "JSON value",
  "JavaScript API reference ↗": "JavaScript API reference ↗",
  "JavaScript · {slot0}": "JavaScript · {slot0}",
  "Join": "Join",
  "Join by code": "Join by code",
  "Join {p0}": "Join {p0}",
  "Keep available and resolve": "Keep available and resolve",
  "Keep history": "Keep history",
  "Keep lengths (must already match)": "Keep lengths (must already match)",
  "Keep listening and comparison controls in Preview. Select a delivered version to change through chat.": "Keep listening and comparison controls in Preview. Select a delivered version to change through chat.",
  "Keep mine as a new skin": "Keep mine as a new skin",
  "Keep my current account": "Keep my current account",
  "Keep the melody, but make calm more spacious…": "Keep the melody, but make calm more spacious…",
  "Keep this family namespace. Import a fork to create a different family.": "Keep this family namespace. Import a fork to create a different family.",
  "Known-cost subtotal": "Known-cost subtotal",
  "Ladders": "Ladders",
  "Language": "Language",
  "Large": "Large",
  "Last {slot0} day": {
    "one": "Last {slot0} day",
    "other": "Last {slot0} days"
  },
  "Last {slot0} days": "Last {slot0} days",
  "Late": "Late",
  "Layer": "Layer",
  "Leaderboard": "Leaderboard",
  "Leaderboard participants": "Leaderboard participants",
  "Leaderboards": "Leaderboards",
  "Leave the room instead.": "Leave the room instead.",
  "Leave this set and discard unsaved changes?": "Leave this set and discard unsaved changes?",
  "Leave with unsaved changes? A recovery copy stays on this device.": "Leave with unsaved changes? A recovery copy stays on this device.",
  "Leave with unsaved edits? A recovery copy stays on this device.": "Leave with unsaved edits? A recovery copy stays on this device.",
  "Length repair": "Length repair",
  "Library": "Library",
  "Licence": "Licence",
  "License": "License",
  "License for this version": "License for this version",
  "License: {slot0}": "License: {slot0}",
  "License: {slot0} · AI composition is disclosed.": "License: {slot0} · AI composition is disclosed.",
  "Lift ban": "Lift ban",
  "Light": "Light",
  "Like": "Like",
  "Likes": "Likes",
  "Limit must be between 1 and 100.": "Limit must be between 1 and 100.",
  "Link a recoverable account first.": "Link a recoverable account first.",
  "Link an active recoverable account before purchasing.": "Link an active recoverable account before purchasing.",
  "Link an active recoverable account to sync drafts.": "Link an active recoverable account to sync drafts.",
  "Listening note": "Listening note",
  "Live AI playtest revision {value0}": "Live AI playtest revision {value0}",
  "Live updates are unavailable. Refreshing saved work…": "Live updates are unavailable. Refreshing saved work…",
  "Load account changes": "Load account changes",
  "Load earlier conversation and versions": "Load earlier conversation and versions",
  "Load more": "Load more",
  "Load more drafts": "Load more drafts",
  "Loading ": "Loading ",
  "Loading code editor…": "Loading code editor…",
  "Loading comparison…": "Loading comparison…",
  "Loading drafts…": "Loading drafts…",
  "Loading editor…": "Loading editor…",
  "Loading engine…": "Loading engine…",
  "Loading game…": "Loading game…",
  "Loading map preview…": "Loading map preview…",
  "Loading matches…": "Loading matches…",
  "Loading music…": "Loading music…",
  "Loading preview…": "Loading preview…",
  "Loading reports…": "Loading reports…",
  "Loading revision comparison…": "Loading revision comparison…",
  "Loading sets…": "Loading sets…",
  "Loading set…": "Loading set…",
  "Loading the inspected version…": "Loading the inspected version…",
  "Loading this version…": "Loading this version…",
  "Loading your building workspace…": "Loading your building workspace…",
  "Loading your skins…": "Loading your skins…",
  "Loading…": "Loading…",
  "Local accounts are not enabled on this instance.": "Local accounts are not enabled on this instance.",
  "Local accounts are not enabled.": "Local accounts are not enabled.",
  "Loop continuity": "Loop continuity",
  "Lost": "Lost",
  "Made": "Made",
  "Made for your next match.": "Made for your next match.",
  "Made with": "Made with",
  "Main": "Main",
  "Main material": "Main material",
  "Make public": "Make public",
  "Malformed Authorization header.": "Malformed Authorization header.",
  "Manage": "Manage",
  "Manage credits": "Manage credits",
  "Manage published family": "Manage published family",
  "Manage the credits for your in-game AI commander.": "Manage the credits for your in-game AI commander.",
  "Manifest": "Manifest",
  "Manifest JSON: {slot0}": "Manifest JSON: {slot0}",
  "Manifest release revision: {slot0}. Publishing a new release requires a larger manifest revision.": "Manifest release revision: {slot0}. Publishing a new release requires a larger manifest revision.",
  "Manual blend · Calm → Building → Combat": "Manual blend · Calm → Building → Combat",
  "Map": "Map",
  "Map Studio": "Map Studio",
  "Map build": "Map build",
  "Map build: {value0}": "Map build: {value0}",
  "Map canvas": "Map canvas",
  "Map comparison": "Map comparison",
  "Map credits": "Map credits",
  "Map design conversation": "Map design conversation",
  "Map designer": "Map designer",
  "Map details": "Map details",
  "Map file (.map or .map.gz)": "Map file (.map or .map.gz)",
  "Map file (.map or .map.gz, from the game or its map editor)": "Map file (.map or .map.gz, from the game or its map editor)",
  "Map generator": "Map generator",
  "Map generators": "Map generators",
  "Map library": "Map library",
  "Map lists": "Map lists",
  "Map location {value0}, {value1}": "Map location {value0}, {value1}",
  "Map page": "Map page",
  "Map preview · validation did not pass": "Map preview · validation did not pass",
  "Map projects": "Map projects",
  "Map settings": "Map settings",
  "Map version uploaded {slot0}": "Map version uploaded {slot0}",
  "Map viewport. Use plus and minus to zoom, arrow keys to pan, or zero to fit.": "Map viewport. Use plus and minus to zoom, arrow keys to pan, or zero to fit.",
  "Map workshop": "Map workshop",
  "Map-credit sales are not enabled.": "Map-credit sales are not enabled.",
  "Maps": "Maps",
  "Maps players love": "Maps players love",
  "Maps players shared. Rooms play them by version, so everyone loads the same file.": "Maps players shared. Rooms play them by version, so everyone loads the same file.",
  "Maps you shared, whatever their visibility.": "Maps you shared, whatever their visibility.",
  "Mark this generation failed and return {value0} reserved product credit(s)? Confirm that its delivery cannot be recovered.": "Mark this generation failed and return {value0} reserved product credit(s)? Confirm that its delivery cannot be recovered.",
  "Match": "Match",
  "Match activity": "Match activity",
  "Match colony skins": "Match colony skins",
  "Match id, account id, player name or relay": "Match id, account id, player name or relay",
  "Match not found.": "Match not found.",
  "Match record": "Match record",
  "Matches": "Matches",
  "Matches you played stay in other players’ history, and their replay files still contain the name you had in the game.": "Matches you played stay in other players’ history, and their replay files still contain the name you had in the game.",
  "Matching lengths does not align beats or harmony.": "Matching lengths does not align beats or harmony.",
  "Material": "Material",
  "Material map pixels must be fully opaque.": "Material map pixels must be fully opaque.",
  "Material map pixels must be grey: red, green and blue equal to the material id.": "Material map pixels must be grey: red, green and blue equal to the material id.",
  "Material map pixels must be material ids 0 to {p0}.": "Material map pixels must be material ids 0 to {p0}.",
  "Material yields": "Material yields",
  "Maxima": "Maxima",
  "Maximum health": "Maximum health",
  "Maximum seconds": "Maximum seconds",
  "Mean seconds per successful delivery, with the number of measured completions.": "Mean seconds per successful delivery, with the number of measured completions.",
  "Measure": "Measure",
  "Measured by the relay; typical value first, then the 95th percentile. Ping: round trip between the player and the relay. {slot0} Behind: how far the player’s game ran behind the match clock, their input delay included. {slot1} Quality is the worst of these and of reconnects, time offline and delayed orders. Offline: time disconnected before reconnecting. Delayed orders: orders that ran a tick later than asked.": "Measured by the relay; typical value first, then the 95th percentile. Ping: round trip between the player and the relay. {slot0} Behind: how far the player’s game ran behind the match clock, their input delay included. {slot1} Quality is the worst of these and of reconnects, time offline and delayed orders. Offline: time disconnected before reconnecting. Delayed orders: orders that ran a tick later than asked.",
  "Measured from creation to completion, grouped by request creation day. Only successful requests/jobs with a known completion time contribute; late completions update their original period.": "Measured from creation to completion, grouped by request creation day. Only successful requests/jobs with a known completion time contribute; late completions update their original period.",
  "Measured model usage is charged, including code that later fails tests.": "Measured model usage is charged, including code that later fails tests.",
  "Measurements flag possible defects. Your ears decide whether the music feels right.": "Measurements flag possible defects. Your ears decide whether the music feels right.",
  "Medium": "Medium",
  "Meet the colonies. Find a player, explore their games, or get to know your next AI opponent.": "Meet the colonies. Find a player, explore their games, or get to know your next AI opponent.",
  "Metric": "Metric",
  "Minimum seconds": "Minimum seconds",
  "Minimum total stock": "Minimum total stock",
  "Mirrored bands": "Mirrored bands",
  "Mirrored spots": "Mirrored spots",
  "Missing": "Missing",
  "Missing historical measurements are unavailable, rather than reconstructed from last-seen timestamps. Current periods may be partial. Retained account markers cover 90 days; anonymous daily totals cover 24 months.": "Missing historical measurements are unavailable, rather than reconstructed from last-seen timestamps. Current periods may be partial. Retained account markers cover 90 days; anonymous daily totals cover 24 months.",
  "Missing payment signature.": "Missing payment signature.",
  "Mix and master": "Mix and master",
  "Mix balance": "Mix balance",
  "Model / stage": "Model / stage",
  "Model and camera versions do not match. Reload to update.": "Model and camera versions do not match. Reload to update.",
  "Model to paint": "Model to paint",
  "Moderate": "Moderate",
  "Moderation": "Moderation",
  "Moderation reason": "Moderation reason",
  "Moderation reports": "Moderation reports",
  "Moderation visibility": "Moderation visibility",
  "Moderator": "Moderator",
  "Moderator access is required.": "Moderator access is required.",
  "Mood contrast": "Mood contrast",
  "Mood synchronization": "Mood synchronization",
  "More": "More",
  "More actions for {value0}": "More actions for {value0}",
  "Most downloaded": "Most downloaded",
  "Most liked": "Most liked",
  "Most recent provider attempts; unavailable usage is not zero. These numbers need verification against provider evidence.": "Most recent provider attempts; unavailable usage is not zero. These numbers need verification against provider evidence.",
  "Mottled": "Mottled",
  "Music": "Music",
  "Music Studio": "Music Studio",
  "Music composition conversation": "Music composition conversation",
  "Music couldn’t be loaded.": "Music couldn’t be loaded.",
  "Music credits": "Music credits",
  "Music for your colony": "Music for your colony",
  "Music is unavailable.": "Music is unavailable.",
  "Music projects": "Music projects",
  "Music reports": "Music reports",
  "Music revisions": "Music revisions",
  "Music-credit sales are not enabled.": "Music-credit sales are not enabled.",
  "Musical variety": "Musical variety",
  "Mute {slot0}": "Mute {slot0}",
  "My AIs": "My AIs",
  "My Colony": "My Colony",
  "My colony": "My colony",
  "My families": "My families",
  "My favourites": "My favourites",
  "My generators": "My generators",
  "My landscape": "My landscape",
  "My maps": "My maps",
  "My sets": "My sets",
  "My skins": "My skins",
  "Name": "Name",
  "Name or content ID": "Name or content ID",
  "Name, account id or email": "Name, account id or email",
  "Names like Guest-1234 are reserved for guests.": "Names like Guest-1234 are reserved for guests.",
  "Navigation": "Navigation",
  "Needs attention": "Needs attention",
  "New AI version": "New AI version",
  "New building family": "New building family",
  "New composition": "New composition",
  "New display name": "New display name",
  "New here? Create an account": "New here? Create an account",
  "New map": "New map",
  "New messages ": "New messages ",
  "New set": "New set",
  "New skin": "New skin",
  "New terrain set": "New terrain set",
  "New to Globulation 2?": "New to Globulation 2?",
  "New version": "New version",
  "Newest": "Newest",
  "Newest reports": "Newest reports",
  "News": "News",
  "Next": "Next",
  "Next page": "Next page",
  "Next results": "Next results",
  "Next stage": "Next stage",
  "Next stage: {slot0}": "Next stage: {slot0}",
  "Nicowar": "Nicowar",
  "No AIs match these filters.": "No AIs match these filters.",
  "No Android app is associated with this instance.": "No Android app is associated with this instance.",
  "No account needed to try it:": "No account needed to try it:",
  "No accounts match.": "No accounts match.",
  "No actions found.": "No actions found.",
  "No active account.": "No active account.",
  "No attempt usage evidence is available.": "No attempt usage evidence is available.",
  "No building validation engine is available. Try again later.": "No building validation engine is available. Try again later.",
  "No commander activity yet.": "No commander activity yet.",
  "No comparison": "No comparison",
  "No compatible engine is available for this map.": "No compatible engine is available for this map.",
  "No confirmed cash events in this range and payment mode.": "No confirmed cash events in this range and payment mode.",
  "No content found.": "No content found.",
  "No data yet.": "No data yet.",
  "No engine agent can check files right now.": "No engine agent can check files right now.",
  "No engine agent can validate maps right now.": "No engine agent can validate maps right now.",
  "No engine agents are registered.": "No engine agents are registered.",
  "No families found.": "No families found.",
  "No game servers are online right now.": "No game servers are online right now.",
  "No games yet. This AI’s results will appear here after it plays.": "No games yet. This AI’s results will appear here after it plays.",
  "No generators match these filters.": "No generators match these filters.",
  "No iOS app is associated with this instance.": "No iOS app is associated with this instance.",
  "No isolated AI validator is available.": "No isolated AI validator is available.",
  "No isolated AI validator is available. Please try again later.": "No isolated AI validator is available. Please try again later.",
  "No isolated generator validator is available.": "No isolated generator validator is available.",
  "No isolated generator validator is available. Please try again later.": "No isolated generator validator is available. Please try again later.",
  "No isolated generator worker is available.": "No isolated generator worker is available.",
  "No map build has started. Waiting for the provider outcome.": "No map build has started. Waiting for the provider outcome.",
  "No maps match these filters.": "No maps match these filters.",
  "No matches yet.": "No matches yet.",
  "No measured results are available for this version.": "No measured results are available for this version.",
  "No music found. Try different filters, or share the first set.": "No music found. Try different filters, or share the first set.",
  "No open reports.": "No open reports.",
  "No other relay is available; try again shortly.": "No other relay is available; try again shortly.",
  "No owned building family.": "No owned building family.",
  "No owned {p0} version.": "No owned {p0} version.",
  "No photo.": "No photo.",
  "No players found. Try another name.": "No players found. Try another name.",
  "No queue {p0}.": "No queue {p0}.",
  "No queue.": "No queue.",
  "No rated players in this view yet. Play a ranked match to start climbing.": "No rated players in this view yet. Play a ranked match to start climbing.",
  "No rated players yet. The first wins will put you here.": "No rated players yet. The first wins will put you here.",
  "No relay accepted the match.": "No relay accepted the match.",
  "No reports.": "No reports.",
  "No requests need attention.": "No requests need attention.",
  "No set validator is available. Your draft is saved; try checks later.": "No set validator is available. Your draft is saved; try checks later.",
  "No sets found. Try another search or create the first one.": "No sets found. Try another search or create the first one.",
  "No shared maps yet. Be the first to share one.": "No shared maps yet. Be the first to share one.",
  "No sign-in provider {p0}.": "No sign-in provider {p0}.",
  "No skin reports.": "No skin reports.",
  "No such AI version.": "No such AI version.",
  "No such AI.": "No such AI.",
  "No such account.": "No such account.",
  "No such agent.": "No such agent.",
  "No such artifact.": "No such artifact.",
  "No such artwork.": "No such artwork.",
  "No such blob.": "No such blob.",
  "No such building family.": "No such building family.",
  "No such delivered map.": "No such delivered map.",
  "No such draft.": "No such draft.",
  "No such generator.": "No such generator.",
  "No such job.": "No such job.",
  "No such leaderboard.": "No such leaderboard.",
  "No such map.": "No such map.",
  "No such match.": "No such match.",
  "No such music release.": "No such music release.",
  "No such player.": "No such player.",
  "No such proposal.": "No such proposal.",
  "No such queue ticket.": "No such queue ticket.",
  "No such release.": "No such release.",
  "No such report.": "No such report.",
  "No such room.": "No such room.",
  "No such sign-in on this connection.": "No such sign-in on this connection.",
  "No such sign-in.": "No such sign-in.",
  "No such track.": "No such track.",
  "No such upload.": "No such upload.",
  "No such version.": "No such version.",
  "No timeline was recorded for this match.": "No timeline was recorded for this match.",
  "No uncertain request.": "No uncertain request.",
  "No unpublished drafts.": "No unpublished drafts.",
  "No validated building release.": "No validated building release.",
  "No validated release": "No validated release",
  "No worker leases are recorded.": "No worker leases are recorded.",
  "No {p0} sign-in is linked to this account.": "No {p0} sign-in is linked to this account.",
  "Nobody": "Nobody",
  "None": "None",
  "None: this guest account lives on the device that created it.": "None: this guest account lives on the device that created it.",
  "Not AI-generated": "Not AI-generated",
  "Not applicable": "Not applicable",
  "Not available yet": "Not available yet",
  "Not evaluated": "Not evaluated",
  "Not found.": "Not found.",
  "Not found. It may have been removed, or the link is wrong.": "Not found. It may have been removed, or the link is wrong.",
  "Not hidden": "Not hidden",
  "Not run": "Not run",
  "Not saved": "Not saved",
  "Notes": "Notes",
  "Nothing changed": "Nothing changed",
  "Nothing here: this page wandered off like an explorer glob. {slot0}.": "Nothing here: this page wandered off like an explorer glob. {slot0}.",
  "Numbi": "Numbi",
  "OK": "OK",
  "Offensive": "Offensive",
  "Offline": "Offline",
  "Offline · changes pending": "Offline · changes pending",
  "Older reports": "Older reports",
  "Oldest queued engine job: {slot0}": "Oldest queued engine job: {slot0}",
  "One .js file · up to 128 KiB · profiles 1 and 2": "One .js file · up to 128 KiB · profiles 1 and 2",
  "One melody. Three moods.": "One melody. Three moods.",
  "One soundtrack, three synchronized moods. Switch moods while listening to hear how the game adapts.": "One soundtrack, three synchronized moods. Switch moods while listening to hear how the game adapts.",
  "One-time purchases stay with your account. Preview and paint before buying.": "One-time purchases stay with your account. Preview and paint before buying.",
  "Only a successfully converted release can be published.": "Only a successfully converted release can be published.",
  "Only continue if you just started signing in from your own game and it shows the same code. If someone sent you this link, cancel.": "Only continue if you just started signing in from your own game and it shows the same code. If someone sent you this link, cancel.",
  "Only if you have installed the game on this device.": "Only if you have installed the game on this device.",
  "Only me": "Only me",
  "Only registered accounts can be moderators or administrators.": "Only registered accounts can be moderators or administrators.",
  "Only the host assigns seats in this room.": "Only the host assigns seats in this room.",
  "Only the host can add AIs.": "Only the host can add AIs.",
  "Only the host can change the room.": "Only the host can change the room.",
  "Only the host can empty other seats.": "Only the host can empty other seats.",
  "Only the host can lock seats.": "Only the host can lock seats.",
  "Only the host can remove players.": "Only the host can remove players.",
  "Only the host can start the match.": "Only the host can start the match.",
  "Only the map owner can do that.": "Only the map owner can do that.",
  "Only uncertain calls can be reconciled.": "Only uncertain calls can be reconciled.",
  "Only uncertain requests need reconciliation.": "Only uncertain requests need reconciliation.",
  "Opacity ": "Opacity ",
  "Open": "Open",
  "Open AI Map Studio": "Open AI Map Studio",
  "Open Building families when creating a new game or a new map in the editor, install a compatible release, and enable it. Enabled families apply to future generated maps alongside stock buildings. Existing maps and saves keep their own buildings.": "Open Building families when creating a new game or a new map in the editor, install a compatible release, and enable it. Enabled families apply to future generated maps alongside stock buildings. Existing maps and saves keep their own buildings.",
  "Open in installed app": "Open in installed app",
  "Open in the Globulation 2 app": "Open in the Globulation 2 app",
  "Open music release": "Open music release",
  "Open navigation": "Open navigation",
  "Open the map editor’s Set Library to import a release, or import this downloaded package. Only custom content is included in shared maps. Each map keeps its own editable copy.": "Open the map editor’s Set Library to import a release, or import this downloaded package. Only custom content is included in shared maps. Each map keeps its own editable copy.",
  "Open {target} ↗": "Open {target} ↗",
  "Opening Globulation 2…": "Opening Globulation 2…",
  "Opening studio…": "Opening studio…",
  "Opening your studio…": "Opening your studio…",
  "Opens the app if it is installed.": "Opens the app if it is installed.",
  "Operations": "Operations",
  "Opponent": "Opponent",
  "Orders the server refused (a modified or broken client sends these)": "Orders the server refused (a modified or broken client sends these)",
  "Original game artwork": "Original game artwork",
  "Other": "Other",
  "Output tokens": "Output tokens",
  "Overview": "Overview",
  "Owned": "Owned",
  "PLAYABLE MAP": "PLAYABLE MAP",
  "Package": "Package",
  "Pad ends with silence to longest": "Pad ends with silence to longest",
  "Page not found": "Page not found",
  "Paint color": "Paint color",
  "Paint directly on the 3D {value0} model": "Paint directly on the 3D {value0} model",
  "Paint repeats on matching surfaces": "Paint repeats on matching surfaces",
  "Paint tools": "Paint tools",
  "Painting is unavailable in this browser.": "Painting is unavailable in this browser.",
  "Painting needs WebGL 2. You can still save your draft, browse My skins, or visit the shop.": "Painting needs WebGL 2. You can still save your draft, browse My skins, or visit the shop.",
  "Passed": "Passed",
  "Password": "Password",
  "Passwords can be at most {p0} characters.": "Passwords can be at most {p0} characters.",
  "Paste the invite link, or type its code (6 to 16 letters and digits).": "Paste the invite link, or type its code (6 to 16 letters and digits).",
  "Pattern color": "Pattern color",
  "Pattern coverage": "Pattern coverage",
  "Pattern rotation": "Pattern rotation",
  "Pattern size": "Pattern size",
  "Patterns": "Patterns",
  "Patterns & fills": "Patterns & fills",
  "Pause": "Pause",
  "Payment": "Payment",
  "Payment mode": "Payment mode",
  "Payment status: {value0}.": "Payment status: {value0}.",
  "Payments are not configured.": "Payments are not configured.",
  "Pen pressure": "Pen pressure",
  "Pending": "Pending",
  "Period": "Period",
  "Petals cupped open around a central bud.": "Petals cupped open around a central bud.",
  "Photo updated.": "Photo updated.",
  "Ping": "Ping",
  "Play": "Play",
  "Play Locally in Custom Game": "Play Locally in Custom Game",
  "Play as {p3} instead": "Play as {p3} instead",
  "Play in Multiplayer": "Play in Multiplayer",
  "Play in browser": "Play in browser",
  "Play in your browser": "Play in your browser",
  "Play online": "Play online",
  "Play this map": "Play this map",
  "Play {slot0}": "Play {slot0}",
  "Playability checks": "Playability checks",
  "Playability checks passed": "Playability checks passed",
  "Playable": "Playable",
  "Playable generator": "Playable generator",
  "Playable terrain": "Playable terrain",
  "Playback format": "Playback format",
  "Playback position": "Playback position",
  "Player": "Player",
  "Player guides": "Player guides",
  "Player types": "Player types",
  "Players": "Players",
  "Players and AI opponents, ranked by their conservative rating: it rises as the game becomes sure of your skill. Guests are not ranked.": "Players and AI opponents, ranked by their conservative rating: it rises as the game becomes sure of your skill. Guests are not ranked.",
  "Players and results": "Players and results",
  "Players cannot be removed while a match is starting or running.": "Players cannot be removed while a match is starting or running.",
  "Players online": "Players online",
  "Plays": "Plays",
  "Please fix the issues in the attached test diagnostics.": "Please fix the issues in the attached test diagnostics.",
  "Please try building the map again and address this issue: {value0}": "Please try building the map again and address this issue: {value0}",
  "Pose": "Pose",
  "Prepare Calm, Building, and Combat arrangements of the same piece. Each must last 10 seconds to 15 minutes. Originals are deleted after conversion; keep your own source files.": "Prepare Calm, Building, and Combat arrangements of the same piece. Each must last 10 seconds to 15 minutes. Originals are deleted after conversion; keep your own source files.",
  "Prepare retry": "Prepare retry",
  "Prepare the design": "Prepare the design",
  "Prepare this release": "Prepare this release",
  "Preparing photo…": "Preparing photo…",
  "Preparing your model…": "Preparing your model…",
  "Prestige ": "Prestige ",
  "Prestige {slot0}": "Prestige {slot0}",
  "Preview": "Preview",
  "Preview current changes": "Preview current changes",
  "Preview game transitions": "Preview game transitions",
  "Preview not found.": "Preview not found.",
  "Preview of {value0}": "Preview of {value0}",
  "Preview unavailable": "Preview unavailable",
  "Preview unavailable.": "Preview unavailable.",
  "Preview · {value0}": "Preview · {value0}",
  "Previewing game transitions · {slot0} · game fade timing": "Previewing game transitions · {slot0} · game fade timing",
  "Previous": "Previous",
  "Previous mean": "Previous mean",
  "Previous recorded": "Previous recorded",
  "Previous samples": "Previous samples",
  "Previous saved drafts": "Previous saved drafts",
  "Previous stage": "Previous stage",
  "Priced": "Priced",
  "Private": "Private",
  "Private or uploaded map": "Private or uploaded map",
  "Private project": "Private project",
  "Private — only you": "Private — only you",
  "Processing": "Processing",
  "Product": "Product",
  "Product / model": "Product / model",
  "Product credit flow table": "Product credit flow table",
  "Product credits": "Product credits",
  "Profile photo": "Profile photo",
  "Profile {slot0} · {slot1} downloads of this version": "Profile {slot0} · {slot1} downloads of this version",
  "Progress does not match the leased AI validation.": "Progress does not match the leased AI validation.",
  "Project": "Project",
  "Project actions": "Project actions",
  "Project has not loaded.": "Project has not loaded.",
  "Project name": "Project name",
  "Project options": "Project options",
  "Project title": "Project title",
  "Projects onto visible surfaces. Shared surfaces repeat the paint.": "Projects onto visible surfaces. Shared surfaces repeat the paint.",
  "Properties inherit this preset until you add an override.": "Properties inherit this preset until you add an override.",
  "Provider attempt evidence for {value0}": "Provider attempt evidence for {value0}",
  "Provider cost table": "Provider cost table",
  "Public": "Public",
  "Public library": "Public library",
  "Public — listed for everyone": "Public — listed for everyone",
  "Publish": "Publish",
  "Publish a generator release": "Publish a generator release",
  "Publish a new release": "Publish a new release",
  "Publish a new version": "Publish a new version",
  "Publish a release": "Publish a release",
  "Publish a version": "Publish a version",
  "Publish map version": "Publish map version",
  "Publish music version": "Publish music version",
  "Publish release": "Publish release",
  "Publish revision {slot0}": "Publish revision {slot0}",
  "Publish revision {value0}": "Publish revision {value0}",
  "Publish saved family": "Publish saved family",
  "Publish saved revision {value0}": "Publish saved revision {value0}",
  "Publish saved soundtrack {slot0} to the public Music library. Only this exact version is shared.": "Publish saved soundtrack {slot0} to the public Music library. Only this exact version is shared.",
  "Publish the selected saved map ({slot0}) to the public Map library.": "Publish the selected saved map ({slot0}) to the public Map library.",
  "Publish this release": "Publish this release",
  "Publish this version": "Publish this version",
  "Published": "Published",
  "Published description": "Published description",
  "Published family name": "Published family name",
  "Published release": "Published release",
  "Published visibility": "Published visibility",
  "Published {slot0}.": "Published {slot0}.",
  "Publishing allows reuse under {slot0}, including embedding and editing this content in shared maps. Confirm that the credits and reuse rights cover every uploaded image.": "Publishing allows reuse under {slot0}, including embedding and editing this content in shared maps. Confirm that the credits and reuse rights cover every uploaded image.",
  "Publishing preserves these exact source bytes. Changes require a new version.": "Publishing preserves these exact source bytes. Changes require a new version.",
  "Purchase": "Purchase",
  "Purchase confirmed. Your skin is ready to use in game.": "Purchase confirmed. Your skin is ready to use in game.",
  "Purchase not found.": "Purchase not found.",
  "Purchases are not configured on this server yet.": "Purchases are not configured on this server yet.",
  "Quality": "Quality",
  "Questions and brainstorming are free and require an available credit. A creation or revision request starts one build of up to 12 entries. Failed generations return their reservation.": "Questions and brainstorming are free and require an available credit. A creation or revision request starts one build of up to 12 entries. Failed generations return their reservation.",
  "Questions and brainstorming are free. A creation or revision request starts one build of up to 12 building variants. Failed generations return their reservation.": "Questions and brainstorming are free. A creation or revision request starts one build of up to 12 building variants. Failed generations return their reservation.",
  "Queued": "Queued",
  "Queues the stored match record for verification again. Force permits replacement of an existing verification result; confirm it separately.": "Queues the stored match record for verification again. Force permits replacement of an existing verification result; confirm it separately.",
  "Quick-match games and public rooms, newest first.": "Quick-match games and public rooms, newest first.",
  "Quiet passage audibility": "Quiet passage audibility",
  "Range": "Range",
  "Rank": "Rank",
  "Rate": "Rate",
  "Rate {slot0}: {slot1} credit per million input tokens, {slot2} for cached input, {slot3} for cache writes, and {slot4} for output including reasoning. Repairs and follow-ups use the same rates.": {
    "one": "Rate {slot0}: {slot1} credit per million input tokens, {slot2} for cached input, {slot3} for cache writes, and {slot4} for output including reasoning. Repairs and follow-ups use the same rates.",
    "other": "Rate {slot0}: {slot1} credits per million input tokens, {slot2} for cached input, {slot3} for cache writes, and {slot4} for output including reasoning. Repairs and follow-ups use the same rates."
  },
  "Rate {slot0}: {slot1} credits per million input tokens, {slot2} for cached input, {slot3} for cache writes, and {slot4} for output including reasoning. Repairs and follow-ups use the same rates.": "Rate {slot0}: {slot1} credits per million input tokens, {slot2} for cached input, {slot3} for cache writes, and {slot4} for output including reasoning. Repairs and follow-ups use the same rates.",
  "Rated queues are for registered accounts; sign in first.": "Rated queues are for registered accounts; sign in first.",
  "Rating": "Rating",
  "Rating after each rated match": "Rating after each rated match",
  "Re-verify ": "Re-verify ",
  "Re-verify {slot0}": "Re-verify {slot0}",
  "Reach to Infinity": "Reach to Infinity",
  "Ready": "Ready",
  "Ready for your next adventure": "Ready for your next adventure",
  "Ready to download": "Ready to download",
  "Ready to listen": "Ready to listen",
  "Ready to play": "Ready to play",
  "Ready to publish": "Ready to publish",
  "Ready to use": "Ready to use",
  "Reason": "Reason",
  "Reason ": "Reason ",
  "Reason (recorded in the audit log)": "Reason (recorded in the audit log)",
  "Reason and evidence": "Reason and evidence",
  "Reason: {slot0}": "Reason: {slot0}",
  "Reasons": "Reasons",
  "Recent activity": "Recent activity",
  "Recent matches": "Recent matches",
  "Recently updated": "Recently updated",
  "Reconcile outstanding credit reservations before deleting this project.": "Reconcile outstanding credit reservations before deleting this project.",
  "Reconcile verified usage": "Reconcile verified usage",
  "Reconciling": "Reconciling",
  "Reconnecting to your saved project…": "Reconnecting to your saved project…",
  "Recorded usage: {slot0} input tokens · {slot1} cached input · {slot2} cache write · {slot3} output tokens": "Recorded usage: {slot0} input tokens · {slot1} cached input · {slot2} cache write · {slot3} output tokens",
  "Recovered edits belong to an older revision. Download them before reloading.": "Recovered edits belong to an older revision. Download them before reloading.",
  "Recovered local edits": "Recovered local edits",
  "Recovery evidence for {value0}": "Recovery evidence for {value0}",
  "Redo": "Redo",
  "Reference": "Reference",
  "Reference limit reached for this project.": "Reference limit reached for this project.",
  "Reference upload could not be saved.": "Reference upload could not be saved.",
  "Refine the composition": "Refine the composition",
  "Refresh": "Refresh",
  "Refresh validation": "Refresh validation",
  "Refund": "Refund",
  "Refunded": "Refunded",
  "Refused": "Refused",
  "Register an account to create and share sets.": "Register an account to create and share sets.",
  "Registered": "Registered",
  "Registered active account-days": "Registered active account-days",
  "Registered player": "Registered player",
  "Registered signups": "Registered signups",
  "Registered: {slot0} today · {slot1} weekly · {slot2} monthly": "Registered: {slot0} today · {slot1} weekly · {slot2} monthly",
  "Rejected": "Rejected",
  "Relay key required.": "Relay key required.",
  "Release": "Release",
  "Release archive failed its integrity check.": "Release archive failed its integrity check.",
  "Release archive is too large.": "Release archive is too large.",
  "Release archive is unavailable.": "Release archive is unavailable.",
  "Release artwork failed its integrity check.": "Release artwork failed its integrity check.",
  "Release exceeds package limits.": "Release exceeds package limits.",
  "Release label": "Release label",
  "Release not found.": "Release not found.",
  "Release notes": "Release notes",
  "Release unavailable.": "Release unavailable.",
  "Releases": "Releases",
  "Releases & credits": "Releases & credits",
  "Reload saved revision": "Reload saved revision",
  "Reload the current saved draft before publishing.": "Reload the current saved draft before publishing.",
  "Remix with AI": "Remix with AI",
  "Remove": "Remove",
  "Remove entry": "Remove entry",
  "Remove favourite": "Remove favourite",
  "Remove generator": "Remove generator",
  "Remove sheet": "Remove sheet",
  "Remove stage": "Remove stage",
  "Remove stock level": "Remove stock level",
  "Remove variant": "Remove variant",
  "Remove {value0}": "Remove {value0}",
  "Rename": "Rename",
  "Render the instruments": "Render the instruments",
  "Rendered by the browser game engine. Run publishing checks to validate the saved revision.": "Rendered by the browser game engine. Run publishing checks to validate the saved revision.",
  "Replace or remove the team layer before changing frame dimensions.": "Replace or remove the team layer before changing frame dimensions.",
  "Replace the gaps too": "Replace the gaps too",
  "Replay": "Replay",
  "Report": "Report",
  "Report AI": "Report AI",
  "Report a problem": "Report a problem",
  "Report already resolved.": "Report already resolved.",
  "Report for {value0}": "Report for {value0}",
  "Report has already been resolved. Refresh to review its resolution.": "Report has already been resolved. Refresh to review its resolution.",
  "Report not found.": "Report not found.",
  "Report reason": "Report reason",
  "Report received.": "Report received.",
  "Report skin": "Report skin",
  "Report this generator": "Report this generator",
  "Report this map": "Report this map",
  "Report this release": "Report this release",
  "Reported": "Reported",
  "Reported skin texture": "Reported skin texture",
  "Reporting range: {slot0} through {slot1} (UTC). Today is still in progress; the previous {slot2} day are complete calendar days. History may be incomplete; comparisons use recorded observations only.": {
    "one": "Reporting range: {slot0} through {slot1} (UTC). Today is still in progress; the previous {slot2} day is a complete calendar day. History may be incomplete; comparisons use recorded observations only.",
    "other": "Reporting range: {slot0} through {slot1} (UTC). Today is still in progress; the previous {slot2} days are complete calendar days. History may be incomplete; comparisons use recorded observations only."
  },
  "Reporting range: {slot0} through {slot1} (UTC). Today is still in progress; the previous {slot2} days are complete calendar days. History may be incomplete; comparisons use recorded observations only.": "Reporting range: {slot0} through {slot1} (UTC). Today is still in progress; the previous {slot2} days are complete calendar days. History may be incomplete; comparisons use recorded observations only.",
  "Reports": "Reports",
  "Request cap": "Request cap",
  "Request cap exceeds the configured limit.": "Request cap exceeds the configured limit.",
  "Request failed.": "Request failed.",
  "Request not found.": "Request not found.",
  "Requests needing attention": "Requests needing attention",
  "Required experiment": "Required experiment",
  "Requires the {p0} role.": "Requires the {p0} role.",
  "Reroll seed": "Reroll seed",
  "Reservation": "Reservation",
  "Reserved": "Reserved",
  "Reserved product credits": "Reserved product credits",
  "Reserved: {slot0} product credits": "Reserved: {slot0} product credits",
  "Reserved: {slot0} product credits{slot1}": "Reserved: {slot0} product credits{slot1}",
  "Reset angle": "Reset angle",
  "Reset filters": "Reset filters",
  "Reset toolbox layout": "Reset toolbox layout",
  "Reset view": "Reset view",
  "Reset · ": "Reset · ",
  "Resize conversation": "Resize conversation",
  "Resolution: {slot0}{slot1}": "Resolution: {slot0}{slot1}",
  "Resolve": "Resolve",
  "Resolve invalid fields before saving.": "Resolve invalid fields before saving.",
  "Resolve the account changes before saving.": "Resolve the account changes before saving.",
  "Resolved": "Resolved",
  "Resolved by disabling": "Resolved by disabling",
  "Resource": "Resource",
  "Resource growth": "Resource growth",
  "Resource placement permissions": "Resource placement permissions",
  "Resources": "Resources",
  "Restart same setup": "Restart same setup",
  "Restore": "Restore",
  "Restore device copy": "Restore device copy",
  "Restore family": "Restore family",
  "Restore game settings": "Restore game settings",
  "Restore skin": "Restore skin",
  "Restore this revision": "Restore this revision",
  "Restore this version as the current draft? The current version stays in history.": "Restore this version as the current draft? The current version stays in history.",
  "Restoring content removes its moderation restriction; each library’s publication rules still apply.": "Restoring content removes its moderation restriction; each library’s publication rules still apply.",
  "Restrictions and deletion require a lower-role account.": "Restrictions and deletion require a lower-role account.",
  "Result": "Result",
  "Reteaming names team {p0} of {p1}.": "Reteaming names team {p0} of {p1}.",
  "Retry": "Retry",
  "Retry 3D canvas": "Retry 3D canvas",
  "Retry image": "Retry image",
  "Retry loading skins": "Retry loading skins",
  "Retry loading studio": "Retry loading studio",
  "Retry preview": "Retry preview",
  "Retry the same request": "Retry the same request",
  "Retry validation": "Retry validation",
  "Retrying": "Retrying",
  "Return reserved credit": "Return reserved credit",
  "Return to final set": "Return to final set",
  "Returning the reservation marks this generation failed. Inspect its details and confirm delivery cannot be recovered first.": "Returning the reservation marks this generation failed. Inspect its details and confirm delivery cannot be recovered first.",
  "Revenue and costs": "Revenue and costs",
  "Review account changes to resume saving": "Review account changes to resume saving",
  "Review operations": "Review operations",
  "Review reports": "Review reports",
  "Review set": "Review set",
  "Revise generated music in Music Studio.": "Revise generated music in Music Studio.",
  "Revise this version": "Revise this version",
  "Revision restored to your saved draft.": "Revision restored to your saved draft.",
  "Revision {slot0}": "Revision {slot0}",
  "Revision {slot0} checks: {slot1}": "Revision {slot0} checks: {slot1}",
  "Revision {value0} · seed {value1} · {value2} seconds": "Revision {value0} · seed {value1} · {value2} seconds",
  "Revision {value0} · tick {value1} · live": "Revision {value0} · tick {value1} · live",
  "Role": "Role",
  "Room": "Room",
  "Room invite": "Room invite",
  "Room match": "Room match",
  "Room matches go back to their room instead.": "Room matches go back to their room instead.",
  "Room to breathe": "Room to breathe",
  "Rooms": "Rooms",
  "Rotate": "Rotate",
  "Rotation ": "Rotation ",
  "Run checks": "Run checks",
  "Run checks & preview": "Run checks & preview",
  "Run checks to create a preview.": "Run checks to create a preview.",
  "Run compatibility checks on the current saved revision first.": "Run compatibility checks on the current saved revision first.",
  "Run identifier already used.": "Run identifier already used.",
  "Running": "Running",
  "Runtime diagnostics ({slot0})": "Runtime diagnostics ({slot0})",
  "Sand": "Sand",
  "Save": "Save",
  "Save and run checks on the current revision before publishing.": "Save and run checks on the current revision before publishing.",
  "Save changes first. Publishing creates a pinned release of the saved package. The engine checks it before people can download it. Private releases are visible only to you; unlisted releases can be opened with their link.": "Save changes first. Publishing creates a pinned release of the saved package. The engine checks it before people can download it. Private releases are visible only to you; unlisted releases can be opened with their link.",
  "Save details": "Save details",
  "Save draft": "Save draft",
  "Save photo": "Save photo",
  "Save published details": "Save published details",
  "Save your changes before importing or uploading artwork. Export uses the saved draft.": "Save your changes before importing or uploading artwork. Export uses the saved draft.",
  "Save your changes before publishing.": "Save your changes before publishing.",
  "Save your draft before leaving for checkout. Device storage is unavailable.": "Save your draft before leaving for checkout. Device storage is unavailable.",
  "Save your manual building edits in Edit before generating, restoring a version, or undoing.": "Save your manual building edits in Edit before generating, restoring a version, or undoing.",
  "Save your manual edits before asking AI to revise the building.": "Save your manual edits before asking AI to revise the building.",
  "Save your manual edits before asking AI to revise the set.": "Save your manual edits before asking AI to revise the set.",
  "Save your manual terrain edits in Edit before generating, restoring a version, or undoing.": "Save your manual terrain edits in Edit before generating, restoring a version, or undoing.",
  "Saved": "Saved",
  "Saved draft history": "Saved draft history",
  "Saved draft · validation remains version-specific.": "Saved draft · validation remains version-specific.",
  "Saving account changes…": "Saving account changes…",
  "Scale": "Scale",
  "Scene and resource gallery": "Scene and resource gallery",
  "Search": "Search",
  "Search AIs": "Search AIs",
  "Search accounts": "Search accounts",
  "Search buildings": "Search buildings",
  "Search maps": "Search maps",
  "Search matches": "Search matches",
  "Search must be at most 64 characters.": "Search must be at most 64 characters.",
  "Search must be text.": "Search must be text.",
  "Search names, descriptions, authors…": "Search names, descriptions, authors…",
  "Search players and AI opponents…": "Search players and AI opponents…",
  "Search titles": "Search titles",
  "Search unavailable": "Search unavailable",
  "Seat {value0}": "Seat {value0}",
  "Seed": "Seed",
  "Select fewer sets: each ZIP is limited to 64 MiB so it can be imported on every game platform.": "Select fewer sets: each ZIP is limited to 64 MiB so it can be imported on every game platform.",
  "Select for download": "Select for download",
  "Selected frame": "Selected frame",
  "Selected music": "Selected music",
  "Selected terrain": "Selected terrain",
  "Send report": "Send report",
  "Send skin report": "Send skin report",
  "Send the blob as the body.": "Send the blob as the body.",
  "Send the file as the request body (Content-Type: application/octet-stream).": "Send the file as the request body (Content-Type: application/octet-stream).",
  "Send the job's lease token in {p0}.": "Send the job's lease token in {p0}.",
  "Send the match record as the body.": "Send the match record as the body.",
  "Set contents": "Set contents",
  "Set exceeds 16 MiB.": "Set exceeds 16 MiB.",
  "Set file not found.": "Set file not found.",
  "Set library": "Set library",
  "Set not found.": "Set not found.",
  "Set preview engine": "Set preview engine",
  "Set reports": "Set reports",
  "Set the goals and your globs get to work. Feed your colony, train your units and explore together.": "Set the goals and your globs get to work. Feed your colony, train your units and explore together.",
  "Set unavailable.": "Set unavailable.",
  "Set up your colonies and AI opponents.": "Set up your colonies and AI opponents.",
  "Set workspace": "Set workspace",
  "Seven smooth spires around a central egg.": "Seven smooth spires around a central egg.",
  "Shape asset length mismatch": "Shape asset length mismatch",
  "Shape the terrain": "Shape the terrain",
  "Share a generator": "Share a generator",
  "Share a map generator": "Share a map generator",
  "Share a map you made in the editor or with a generator.": "Share a map you made in the editor or with a generator.",
  "Share a soundtrack": "Share a soundtrack",
  "Share music": "Share music",
  "Share your AI": "Share your AI",
  "Shop": "Shop",
  "Short seeded games check runtime behaviour, repeatability, and save/resume. Passing does not certify safety or playing strength.": "Short seeded games check runtime behaviour, repeatability, and save/resume. Passing does not certify safety or playing strength.",
  "Show": "Show",
  "Show game view": "Show game view",
  "Show matches from": "Show matches from",
  "Show more": "Show more",
  "Show technical results {slot0}": "Show technical results {slot0}",
  "Shuffle pattern · {slot0}": "Shuffle pattern · {slot0}",
  "Sign in": "Sign in",
  "Sign in first (session.authenticate).": "Sign in first (session.authenticate).",
  "Sign in first.": "Sign in first.",
  "Sign in or link your account": "Sign in or link your account",
  "Sign in to Globulation 2": "Sign in to Globulation 2",
  "Sign in to Globulation 2 {p0}? Your game shows this code:": "Sign in to Globulation 2 {p0}? Your game shows this code:",
  "Sign in to create": "Sign in to create",
  "Sign in to create a building": "Sign in to create a building",
  "Sign in to create a set": "Sign in to create a set",
  "Sign in to download the match record.": "Sign in to download the match record.",
  "Sign in to download this map.": "Sign in to download this map.",
  "Sign in to like or favourite": "Sign in to like or favourite",
  "Sign in to like or report": "Sign in to like or report",
  "Sign in to list your maps.": "Sign in to list your maps.",
  "Sign in to play on this server.": "Sign in to play on this server.",
  "Sign in to report this skin": "Sign in to report this skin",
  "Sign in to save": "Sign in to save",
  "Sign in to save your skins.": "Sign in to save your skins.",
  "Sign in to see your account or to delete it.": "Sign in to see your account or to delete it.",
  "Sign in to see your library.": "Sign in to see your library.",
  "Sign in to see your sets.": "Sign in to see your sets.",
  "Sign in to upload a map": "Sign in to upload a map",
  "Sign in to upload a photo.": "Sign in to upload a photo.",
  "Sign in to view draft artwork.": "Sign in to view draft artwork.",
  "Sign in to view your commander and credits.": "Sign in to view your commander and credits.",
  "Sign in with a registered account to compose, refine, and share your own soundtrack.": "Sign in with a registered account to compose, refine, and share your own soundtrack.",
  "Sign in with a registered account to design, refine, and play your own maps.": "Sign in with a registered account to design, refine, and play your own maps.",
  "Sign in with a registered account to publish music.": "Sign in with a registered account to publish music.",
  "Sign in with a registered account to save and publish custom sets.": "Sign in with a registered account to save and publish custom sets.",
  "Sign in with a registered account to use AI Building Studio.": "Sign in with a registered account to use AI Building Studio.",
  "Sign in with a registered account to use AI Map Studio.": "Sign in with a registered account to use AI Map Studio.",
  "Sign in with a registered account to use AI Music Studio.": "Sign in with a registered account to use AI Music Studio.",
  "Sign in with a registered account to use AI Terrain Studio.": "Sign in with a registered account to use AI Terrain Studio.",
  "Sign in with a registered account.": "Sign in with a registered account.",
  "Sign in with an account to like maps.": "Sign in with an account to like maps.",
  "Sign in with an account to publish maps; guests can share unlisted maps.": "Sign in with an account to publish maps; guests can share unlisted maps.",
  "Sign in with an account to publish publicly.": "Sign in with an account to publish publicly.",
  "Sign in with an account to save favourites and like AIs.": "Sign in with an account to save favourites and like AIs.",
  "Sign in with an account to save favourites and like generators.": "Sign in with an account to save favourites and like generators.",
  "Sign in with an active account to save building drafts.": "Sign in with an active account to save building drafts.",
  "Sign in with an active account to save skins.": "Sign in with an active account to save skins.",
  "Sign in with an active account to use a custom skin.": "Sign in with an active account to use a custom skin.",
  "Sign in with an active registered account.": "Sign in with an active registered account.",
  "Sign out": "Sign out",
  "Sign-in cancelled": "Sign-in cancelled",
  "Sign-in methods": "Sign-in methods",
  "Sign-in problem": "Sign-in problem",
  "Sign-in was cancelled.": "Sign-in was cancelled.",
  "Signed in": "Signed in",
  "Signed in as": "Signed in as",
  "Signed in as {slot0} ({slot1}). Every administrative change is recorded.": "Signed in as {slot0} ({slot1}). Every administrative change is recorded.",
  "Signing in with {p0} did not work. Please try again.": "Signing in with {p0} did not work. Please try again.",
  "Simulation {slot0}": "Simulation {slot0}",
  "Singular {value0} camera": "Singular {value0} camera",
  "Six brood eggs nested in a low rim.": "Six brood eggs nested in a low rim.",
  "Size": "Size",
  "Skin artwork is unavailable.": "Skin artwork is unavailable.",
  "Skin artwork not found.": "Skin artwork not found.",
  "Skin collection pages": "Skin collection pages",
  "Skin deleted.": "Skin deleted.",
  "Skin designer": "Skin designer",
  "Skin disabled": "Skin disabled",
  "Skin name": "Skin name",
  "Skin not found.": "Skin not found.",
  "Skin page not found.": "Skin page not found.",
  "Skin report resolutions need at most 1000 characters and disabling for a resolved report.": "Skin report resolutions need at most 1000 characters and disabling for a resolved report.",
  "Skin report status": "Skin report status",
  "Skin reports": "Skin reports",
  "Skin shop": "Skin shop",
  "Skin texture": "Skin texture",
  "Skin version not found.": "Skin version not found.",
  "Skins": "Skins",
  "Skip to content": "Skip to content",
  "Skipped": "Skipped",
  "Small": "Small",
  "Solid": "Solid",
  "Some results could not be displayed.": "Some results could not be displayed.",
  "Something else": "Something else",
  "Something went wrong. Please try again.": "Something went wrong. Please try again.",
  "Sort": "Sort",
  "Sort AIs": "Sort AIs",
  "Sound palette": "Sound palette",
  "Soundtrack mood": "Soundtrack mood",
  "Source code": "Source code",
  "Source identity": "Source identity",
  "Source links (one per line)": "Source links (one per line)",
  "Source set": "Source set",
  "Source too large.": "Source too large.",
  "Source unavailable.": "Source unavailable.",
  "Speckles": "Speckles",
  "Spot size": "Spot size",
  "Spots": "Spots",
  "Spread rate": "Spread rate",
  "Sprite key": "Sprite key",
  "Sprite manifest": "Sprite manifest",
  "Sprite manifest JSON": "Sprite manifest JSON",
  "Spritesheet": "Spritesheet",
  "Spritesheets": "Spritesheets",
  "Stable key": "Stable key",
  "Stage": "Stage",
  "Stage details are not available for this version.": "Stage details are not available for this version.",
  "Stage details could not be loaded.": "Stage details could not be loaded.",
  "Start a project": "Start a project",
  "Start building an AI ↗": "Start building an AI ↗",
  "Start fresh": "Start fresh",
  "Start from a preset": "Start from a preset",
  "Start with one building, add stages for upgrades, then save and publish. Artwork uploads are saved immediately; choose their sprite keys in gameSprite and miniSprite.": "Start with one building, add stages for upgrades, then save and publish. Artwork uploads are saved immediately; choose their sprite keys in gameSprite and miniSprite.",
  "Starting": "Starting",
  "Starting the game…": "Starting the game…",
  "Starting workers": "Starting workers",
  "Statistic": "Statistic",
  "Status": "Status",
  "Status: {slot0}": "Status: {slot0}",
  "Status: {slot0} · Created {slot1}{slot2}": "Status: {slot0} · Created {slot1}{slot2}",
  "Still JPEG, PNG or WebP · up to 10 MiB and 25 megapixels. Choosing Gravatar or initials removes your uploaded photo.": "Still JPEG, PNG or WebP · up to 10 MiB and 25 megapixels. Choosing Gravatar or initials removes your uploaded photo.",
  "Stock levels": "Stock levels",
  "Stop game": "Stop game",
  "Stop preview": "Stop preview",
  "Stop request": "Stop request",
  "Stop transition preview": "Stop transition preview",
  "Stopped": "Stopped",
  "Stripes": "Stripes",
  "Studio": "Studio",
  "Studio credit purchases are not available.": "Studio credit purchases are not available.",
  "Studio view": "Studio view",
  "Submitted": "Submitted",
  "Succeeded": "Succeeded",
  "Supply": "Supply",
  "Supply valid example settings.": "Supply valid example settings.",
  "Sustained notes": "Sustained notes",
  "Swarm shape": "Swarm shape",
  "Swimming movement": "Swimming movement",
  "Synchronized music player": "Synchronized music player",
  "Synth · warm bells, pads & pulse": "Synth · warm bells, pads & pulse",
  "THE LISTENING NOTES": "THE LISTENING NOTES",
  "THE LISTENING ROOM": "THE LISTENING ROOM",
  "TOOLBOX": "TOOLBOX",
  "Tag": "Tag",
  "Tags": "Tags",
  "Tags (comma separated)": "Tags (comma separated)",
  "Take a seat first.": "Take a seat first.",
  "Target ID or type": "Target ID or type",
  "Team": "Team",
  "Team color": "Team color",
  "Team color layers must match the base frame dimensions.": "Team color layers must match the base frame dimensions.",
  "Team {value0}": "Team {value0}",
  "Teams": "Teams",
  "Technical checks do not establish balance or fun.": "Technical checks do not establish balance or fun.",
  "Technical checks passed": "Technical checks passed",
  "Technical details": "Technical details",
  "Tell me about the world you want to hear. We’ll shape the melody, instruments and three moods together.": "Tell me about the world you want to hear. We’ll shape the melody, instruments and three moods together.",
  "Terrain": "Terrain",
  "Terrain & resource sets": "Terrain & resource sets",
  "Terrain & resources": "Terrain & resources",
  "Terrain Studio": "Terrain Studio",
  "Terrain Studio is disabled on this instance. Your saved projects remain available.": "Terrain Studio is disabled on this instance. Your saved projects remain available.",
  "Terrain Studio is disabled.": "Terrain Studio is disabled.",
  "Terrain design conversation": "Terrain design conversation",
  "Terrain frames are 32×32. Resource and decor frames can be up to 64×64. Reupload the same PNG with new dimensions to replace its frame grid; then check its frame mappings.": "Terrain frames are 32×32. Resource and decor frames can be up to 64×64. Reupload the same PNG with new dimensions to replace its frame grid; then check its frame mappings.",
  "Terrain projects": "Terrain projects",
  "Terrain-credit sales are not enabled.": "Terrain-credit sales are not enabled.",
  "Test diagnostics attached.": "Test diagnostics attached.",
  "Test store — real-money checkout is not enabled.": "Test store — real-money checkout is not enabled.",
  "That account cannot sign in.": "That account cannot sign in.",
  "That display name is taken.": "That display name is taken.",
  "That password is not right for this username. Try again.": "That password is not right for this username. Try again.",
  "That player is not in this room.": "That player is not in this room.",
  "That seat is not open.": "That seat is not open.",
  "That username is taken.": "That username is taken.",
  "The 3D canvas could not start.": "The 3D canvas could not start.",
  "The 3D canvas was interrupted. Your painting is safe.": "The 3D canvas was interrupted. Your painting is safe.",
  "The 3D shader could not compile.": "The 3D shader could not compile.",
  "The JavaScript file must use UTF-8.": "The JavaScript file must use UTF-8.",
  "The access token is invalid.": "The access token is invalid.",
  "The account no longer exists.": "The account no longer exists.",
  "The app didn’t open.": "The app didn’t open.",
  "The artwork artifact is not available.": "The artwork artifact is not available.",
  "The browser kept the page from opening.": "The browser kept the page from opening.",
  "The current draft changed. Close this panel and review the new revision.": "The current draft changed. Close this panel and review the new revision.",
  "The designer reply needs reconciliation. No map build has started.": "The designer reply needs reconciliation. No map build has started.",
  "The draft changed during publication. Reload it.": "The draft changed during publication. Reload it.",
  "The draft changed elsewhere. Download your local edits before reloading.": "The draft changed elsewhere. Download your local edits before reloading.",
  "The edit target changed. Choose a saved version in history.": "The edit target changed. Choose a saved version in history.",
  "The file is missing from storage.": "The file is missing from storage.",
  "The file is missing.": "The file is missing.",
  "The file must be no larger than 128 KiB.": "The file must be no larger than 128 KiB.",
  "The first visit downloads the game once. Later visits start from this device's copy.": "The first visit downloads the game once. Later visits start from this device's copy.",
  "The game could not be downloaded.": "The game could not be downloaded.",
  "The game will switch to": "The game will switch to",
  "The generator package must fit the 256 KiB draft limit.": "The generator package must fit the 256 KiB draft limit.",
  "The generator package must use UTF-8.": "The generator package must use UTF-8.",
  "The host removed you from this room; try again later.": "The host removed you from this room; try again later.",
  "The job is leased by another engine agent.": "The job is leased by another engine agent.",
  "The lease expired or the job was already reported.": "The lease expired or the job was already reported.",
  "The leased job does not use this blob.": "The leased job does not use this blob.",
  "The map designer is replying": "The map designer is replying",
  "The map designer is replying…": "The map designer is replying…",
  "The map file is missing from storage.": "The map file is missing from storage.",
  "The map is fine. Saving it.": "The map is fine. Saving it.",
  "The map was created but its file did not upload. Upload it again below.": "The map was created but its file did not upload. Upload it again below.",
  "The match already ended with a different record.": "The match already ended with a different record.",
  "The match has not ended yet.": "The match has not ended yet.",
  "The match is placed on another relay.": "The match is placed on another relay.",
  "The match was played with another game version.": "The match was played with another game version.",
  "The music decoder could not be loaded.": "The music decoder could not be loaded.",
  "The operation could not finish.": "The operation could not finish.",
  "The original swarm: spires ringed around an egg.": "The original swarm: spires ringed around an egg.",
  "The platform is unavailable: {slot0}": "The platform is unavailable: {slot0}",
  "The preview engine did not finish. Check the game runtime and try again.": "The preview engine did not finish. Check the game runtime and try again.",
  "The proposal is over.": "The proposal is over.",
  "The provider outcome must be reconciled before cancellation.": "The provider outcome must be reconciled before cancellation.",
  "The refresh token is not valid.": "The refresh token is not valid.",
  "The replay is available once the server has verified the match.": "The replay is available once the server has verified the match.",
  "The request could not be completed.": "The request could not be completed.",
  "The room changed; apply your change to the latest state.": "The room changed; apply your change to the latest state.",
  "The room has no seat {p0}.": "The room has no seat {p0}.",
  "The room is already starting.": "The room is already starting.",
  "The room is full.": "The room is full.",
  "The room is starting a match.": "The room is starting a match.",
  "The saved draft could not be restored.": "The saved draft could not be restored.",
  "The selected generator release is no longer available for this room.": "The selected generator release is no longer available for this room.",
  "The server first loads the file with the game to check it; the map page is created only if it loads. Unlisted maps are reachable by link only; you can make a map public later.": "The server first loads the file with the game to check it; the map page is created only if it loads. Unlisted maps are reachable by link only; you can make a map public later.",
  "The server’s verified replay. Open it in the game (Load game → Replays) or watch it here.": "The server’s verified replay. Open it in the game (Load game → Replays) or watch it here.",
  "The session has ended.": "The session has ended.",
  "The sheet must be at most 2048×2048 and fit its frame grid exactly.": "The sheet must be at most 2048×2048 and fit its frame grid exactly.",
  "The sign-in response is missing its state.": "The sign-in response is missing its state.",
  "The single JavaScript file must be at most 128 KiB.": "The single JavaScript file must be at most 128 KiB.",
  "The stage audio is not available.": "The stage audio is not available.",
  "The stage image is not available.": "The stage image is not available.",
  "The ticket is no longer waiting.": "The ticket is no longer waiting.",
  "The upload is not ready for this action.": "The upload is not ready for this action.",
  "The uploaded file is not usable: {p0}.": "The uploaded file is not usable: {p0}.",
  "The username {p0} is taken. Choose another one, or sign in above if it is yours.": "The username {p0} is taken. Choose another one, or sign in above if it is yours.",
  "The validation receipt expired. Run checks again.": "The validation receipt expired. Run checks again.",
  "The workspace is still loading.": "The workspace is still loading.",
  "Theme, title or creator": "Theme, title or creator",
  "Theme: dark (night colony)": "Theme: dark (night colony)",
  "Theme: light (meadow)": "Theme: light (meadow)",
  "Theme: same as this device": "Theme: same as this device",
  "There is no account called {p0}.": "There is no account called {p0}.",
  "There is no account called {p0}. Check the spelling{p1}.": "There is no account called {p0}. Check the spelling{p1}.",
  "These details apply to every release. Changing visibility also changes who can download them. Edit building definitions in your Studio draft and publish a new release.": "These details apply to every release. Changing visibility also changes who can download them. Edit building definitions in your Studio draft and publish a new release.",
  "They are playing a match right now; you can join the room and wait for the next one.": "They are playing a match right now; you can join the room and wait for the next one.",
  "Thin": "Thin",
  "This AI has reached its version limit.": "This AI has reached its version limit.",
  "This PNG exceeds the sheet upload limit.": "This PNG exceeds the sheet upload limit.",
  "This account cannot publish generators.": "This account cannot publish generators.",
  "This account cannot upload generators.": "This account cannot upload generators.",
  "This account does not own this colony skin.": "This account does not own this colony skin.",
  "This account is banned.": "This account is banned.",
  "This account was deleted.": "This account was deleted.",
  "This building uses installed game artwork. Create or revise its appearance to preview custom artwork here.": "This building uses installed game artwork. Create or revise its appearance to preview custom artwork here.",
  "This cannot be undone. Deleting your account:": "This cannot be undone. Deleting your account:",
  "This changes the map’s visibility. Conversation history remains private.": "This changes the map’s visibility. Conversation history remains private.",
  "This checkout is already finished.": "This checkout is already finished.",
  "This checkout is being recovered. Check your purchase status before trying again.": "This checkout is being recovered. Check your purchase status before trying again.",
  "This checkout request was already used for another product.": "This checkout request was already used for another product.",
  "This colony skin is unavailable.": "This colony skin is unavailable.",
  "This custom skin belongs to another account.": "This custom skin belongs to another account.",
  "This device has a recovery copy.": "This device has a recovery copy.",
  "This draft already exists. Open it to continue.": "This draft already exists. Open it to continue.",
  "This draft changed or was published. Reload it before saving.": "This draft changed or was published. Reload it before saving.",
  "This draft changed. Check it again.": "This draft changed. Check it again.",
  "This draft changed. Reload it before saving again.": "This draft changed. Reload it before saving again.",
  "This draft changed. Save and check its current revision.": "This draft changed. Save and check its current revision.",
  "This family has 50 releases.": "This family has 50 releases.",
  "This family has been hidden by a moderator.": "This family has been hidden by a moderator.",
  "This family uses stock artwork.": "This family uses stock artwork.",
  "This file is too big: uploads are limited to {p0}.": "This file is too big: uploads are limited to {p0}.",
  "This game version is not supported here; update the game.": "This game version is not supported here; update the game.",
  "This generator has reached its version limit.": "This generator has reached its version limit.",
  "This generator release is unavailable, editor-only, or not validated for this engine.": "This generator release is unavailable, editor-only, or not validated for this engine.",
  "This image could not be loaded.": "This image could not be loaded.",
  "This instance": "This instance",
  "This instance cannot validate files of that version.": "This instance cannot validate files of that version.",
  "This instance cannot validate maps of that version.": "This instance cannot validate maps of that version.",
  "This instance has no rated queues.": "This instance has no rated queues.",
  "This invite has expired or does not exist.": "This invite has expired or does not exist.",
  "This invite has expired or does not exist. Ask for a new link.": "This invite has expired or does not exist. Ask for a new link.",
  "This is the last way to sign in to this account; link another method first.": "This is the last way to sign in to this account; link another method first.",
  "This key belongs to engine agent {p0}.": "This key belongs to engine agent {p0}.",
  "This key belongs to relay {p0}.": "This key belongs to relay {p0}.",
  "This match is still being played.": "This match is still being played.",
  "This music includes AI-generated audio": "This music includes AI-generated audio",
  "This namespace belongs to another author. Fork the family first.": "This namespace belongs to another author. Fork the family first.",
  "This namespace was claimed by another author. Fork it first.": "This namespace was claimed by another author. Fork it first.",
  "This older generation has limited stage history. Available images are preserved.": "This older generation has limited stage history. Available images are preserved.",
  "This package ID is already reserved. Forks need a new ID.": "This package ID is already reserved. Forks need a new ID.",
  "This page is for moderators.": "This page is for moderators.",
  "This password is too short: it has {p0} characters, and passwords need at least {p1}.": "This password is too short: it has {p0} characters, and passwords need at least {p1}.",
  "This preview could not be loaded.": "This preview could not be loaded.",
  "This product is not available for purchase yet.": "This product is not available for purchase yet.",
  "This release label or package is already published.": "This release label or package is already published.",
  "This release no longer accepts uploads.": "This release no longer accepts uploads.",
  "This release uses the current saved draft. Unsaved edits are not included.": "This release uses the current saved draft. Unsaved edits are not included.",
  "This room has closed": "This room has closed",
  "This room has closed. Ask the host for a new invite.": "This room has closed. Ask the host for a new invite.",
  "This room is for another game version.": "This room is for another game version.",
  "This set has reached its 100-draft limit. Delete unused drafts first.": "This set has reached its 100-draft limit. Delete unused drafts first.",
  "This set has reached its 50-release limit.": "This set has reached its 50-release limit.",
  "This set is hidden. {slot0}": "This set is hidden. {slot0}",
  "This sign-in has expired or belongs to another browser.": "This sign-in has expired or belongs to another browser.",
  "This sign-in has expired or was already used. Please start again.": "This sign-in has expired or was already used. Please start again.",
  "This sign-in has expired.": "This sign-in has expired.",
  "This sign-in has expired. Start signing in again from the game.": "This sign-in has expired. Start signing in again from the game.",
  "This sign-in is linked to another account.": "This sign-in is linked to another account.",
  "This sign-in link has expired or belongs to another browser.": "This sign-in link has expired or belongs to another browser.",
  "This sign-in link has expired or was already used. Start signing in again from the game.": "This sign-in link has expired or was already used. Start signing in again from the game.",
  "This sign-in was already opened in another browser.": "This sign-in was already opened in another browser.",
  "This skin changed on another device. Reload it before using it.": "This skin changed on another device. Reload it before using it.",
  "This skin changed on another device. Your changes are safe here.": "This skin changed on another device. Your changes are safe here.",
  "This skin changed on another device. Your work is safe in this browser.": "This skin changed on another device. Your work is safe in this browser.",
  "This source or version label has already been published for this AI.": "This source or version label has already been published for this AI.",
  "This source or version label has already been published for this generator.": "This source or version label has already been published for this generator.",
  "This version has a different or unverified musical timeline. Playback starts from the beginning.": "This version has a different or unverified musical timeline. Playback starts from the beginning.",
  "This version keeps its original map. Create a revision in AI Map Studio or upload an edited copy as a new map.": "This version keeps its original map. Create a revision in AI Map Studio or upload an edited copy as a new map.",
  "This {p0} sign-in already belongs to the player": "This {p0} sign-in already belongs to the player",
  "Three moods. One shared rhythm. Find your next soundtrack.": "Three moods. One shared rhythm. Find your next soundtrack.",
  "Through (UTC)": "Through (UTC)",
  "Time between shots (ticks)": "Time between shots (ticks)",
  "Timeline": "Timeline",
  "Title": "Title",
  "Title, artist, description…": "Title, artist, description…",
  "To play online, publish the generated map in the map library and select it for your room. Download family exports a ZIP for importing or editing in Building Studio.": "To play online, publish the generated map in the map library and select it for your room. Download family exports a ZIP for importing or editing in Building Studio.",
  "Too many live Building Studio connections.": "Too many live Building Studio connections.",
  "Too many live Music Studio connections.": "Too many live Music Studio connections.",
  "Too many live Terrain Studio connections.": "Too many live Terrain Studio connections.",
  "Too many requests.": "Too many requests.",
  "Too many sign-in attempts from here. Wait a minute and try again.": "Too many sign-in attempts from here. Wait a minute and try again.",
  "Too many sign-ins in progress on this connection.": "Too many sign-ins in progress on this connection.",
  "Too many unknown invite codes; try again later.": "Too many unknown invite codes; try again later.",
  "Too many wrong codes, so this sign-in was stopped. Start signing in again from the game.": "Too many wrong codes, so this sign-in was stopped. Start signing in again from the game.",
  "Too many wrong passwords. Wait 15 minutes and try again, or sign in another way.": "Too many wrong passwords. Wait 15 minutes and try again, or sign in another way.",
  "Toolbox options": "Toolbox options",
  "Top library content by lifetime recorded downloads": "Top library content by lifetime recorded downloads",
  "Total health": "Total health",
  "Toubib": "Toubib",
  "Trailing {value0} data": "Trailing {value0} data",
  "Transitioning to {value0}…": "Transitioning to {value0}…",
  "Trim ends to shortest": "Trim ends to shortest",
  "Truncated rig geometry": "Truncated rig geometry",
  "Truncated rig tracks": "Truncated rig tracks",
  "Truncated {value0} payload": "Truncated {value0} payload",
  "Try again": "Try again",
  "Turn around the ring. Height and scale stay fixed.": "Turn around the ring. Height and scale stay fixed.",
  "Type": "Type",
  "Type ": "Type ",
  "Type your display name exactly to confirm.": "Type your display name exactly to confirm.",
  "Type your name, ": "Type your name, ",
  "Typical game": "Typical game",
  "UTC day": "UTC day",
  "Unavailable": "Unavailable",
  "Unavailable cost": "Unavailable cost",
  "Unbounded rig scale": "Unbounded rig scale",
  "Uncertain": "Uncertain",
  "Uncertain requests and queued/failed engine jobs, oldest first.": "Uncertain requests and queued/failed engine jobs, oldest first.",
  "Undo": "Undo",
  "Undo revision": "Undo revision",
  "Unexpected checkout address.": "Unexpected checkout address.",
  "Unhide": "Unhide",
  "Units": "Units",
  "Units can cross": "Units can cross",
  "Units: latest verified match against recent average": "Units: latest verified match against recent average",
  "Unknown": "Unknown",
  "Unknown AI tag.": "Unknown AI tag.",
  "Unknown building sort.": "Unknown building sort.",
  "Unknown contentType.": "Unknown contentType.",
  "Unknown device credential.": "Unknown device credential.",
  "Unknown engine agent key.": "Unknown engine agent key.",
  "Unknown generator tag.": "Unknown generator tag.",
  "Unknown library.": "Unknown library.",
  "Unknown license.": "Unknown license.",
  "Unknown or unavailable catalog map.": "Unknown or unavailable catalog map.",
  "Unknown product.": "Unknown product.",
  "Unknown queue result.": "Unknown queue result.",
  "Unknown queue.": "Unknown queue.",
  "Unknown relay key.": "Unknown relay key.",
  "Unknown set kind.": "Unknown set kind.",
  "Unknown sign-in provider.": "Unknown sign-in provider.",
  "Unknown sort.": "Unknown sort.",
  "Unknown status.": "Unknown status.",
  "Unknown upload slot.": "Unknown upload slot.",
  "Unknown verification state.": "Unknown verification state.",
  "Unlike": "Unlike",
  "Unlisted": "Unlisted",
  "Unlisted (people with the link)": "Unlisted (people with the link)",
  "Unlisted — accessible by link": "Unlisted — accessible by link",
  "Unlock designer": "Unlock designer",
  "Unlock the skin designer to use custom skins.": "Unlock the skin designer to use custom skins.",
  "Unmute": "Unmute",
  "Unreadable icon source: {value0}": "Unreadable icon source: {value0}",
  "Unsaved changes": "Unsaved changes",
  "Unsupported realtime protocol version.": "Unsupported realtime protocol version.",
  "Unsupported rig format": "Unsupported rig format",
  "Unsupported shape clip frames": "Unsupported shape clip frames",
  "Unsupported shape format": "Unsupported shape format",
  "Unverifiable": "Unverifiable",
  "Unverified": "Unverified",
  "Up / down": "Up / down",
  "Update the game to join rooms using shared generators.": "Update the game to join rooms using shared generators.",
  "Update the game to reconnect to this shared generator match.": "Update the game to reconnect to this shared generator match.",
  "Update the game to reconnect to your shared generator room or match.": "Update the game to reconnect to your shared generator room or match.",
  "Update the game to use shared generator rooms and matches.": "Update the game to use shared generator rooms and matches.",
  "Update the game to use shared generators.": "Update the game to use shared generators.",
  "Updated": "Updated",
  "Updated {slot0} · UTC days · {slot1}": "Updated {slot0} · UTC days · {slot1}",
  "Updated {slot0} · UTC periods · {slot1} payments": "Updated {slot0} · UTC periods · {slot1} payments",
  "Upload": "Upload",
  "Upload PNG": "Upload PNG",
  "Upload a map": "Upload a map",
  "Upload all three moods first.": "Upload all three moods first.",
  "Upload already published elsewhere.": "Upload already published elsewhere.",
  "Upload an audio file, or cover art up to 8 MiB.": "Upload an audio file, or cover art up to 8 MiB.",
  "Upload an image as binary data.": "Upload an image as binary data.",
  "Upload artwork you may use as a reference. Up to four selected images guide the visual style.": "Upload artwork you may use as a reference. Up to four selected images guide the visual style.",
  "Upload expired; choose the file again.": "Upload expired; choose the file again.",
  "Upload expired; validate again.": "Upload expired; validate again.",
  "Upload frame": "Upload frame",
  "Upload image bytes.": "Upload image bytes.",
  "Upload photo": "Upload photo",
  "Upload still PNG or WebP frames up to 512 × 512. Team-color layers use the same dimensions as the base frame.": "Upload still PNG or WebP frames up to 512 × 512. Team-color layers use the same dimensions as the base frame.",
  "Upload the map first (POST /api/v1/uploads).": "Upload the map first (POST /api/v1/uploads).",
  "Upload the match record (PUT …/record) first.": "Upload the match record (PUT …/record) first.",
  "Upload the portable JSON exported from Settings → Map generators. {slot0}": "Upload the portable JSON exported from Settings → Map generators. {slot0}",
  "Upload version": "Upload version",
  "Uploaded": "Uploaded",
  "Uploaded spritesheet; click a tile to select its frame": "Uploaded spritesheet; click a tile to select its frame",
  "Uploading": "Uploading",
  "Usage": "Usage",
  "Usage measured": "Usage measured",
  "Use Gravatar": "Use Gravatar",
  "Use a PNG or WebP {p0} no larger than {p1} KiB.": "Use a PNG or WebP {p0} no larger than {p1} KiB.",
  "Use a PNG or WebP {p0}.": "Use a PNG or WebP {p0}.",
  "Use a photo from your device, or the Gravatar associated with a linked email address. Your photo is public.": "Use a photo from your device, or the Gravatar associated with a linked email address. Your photo is public.",
  "Use a valid, still 512 by 512 pixel 8-bit material map.": "Use a valid, still 512 by 512 pixel 8-bit material map.",
  "Use a valid, still 512 by 512 pixel image.": "Use a valid, still 512 by 512 pixel image.",
  "Use buildings in the game": "Use buildings in the game",
  "Use in a map": "Use in a map",
  "Use in game": "Use in game",
  "Use initials": "Use initials",
  "Use reference": "Use reference",
  "Use this view": "Use this view",
  "Use {slot0} in gameSprite or miniSprite to select an uploaded sprite.": "Use {slot0} in gameSprite or miniSprite to select an uploaded sprite.",
  "Used for your next match.": "Used for your next match.",
  "User": "User",
  "Username": "Username",
  "Username and password": "Username and password",
  "Usernames are 3 to 32 characters long; this one has {p0}.": "Usernames are 3 to 32 characters long; this one has {p0}.",
  "Usernames can only use letters, digits, dots, dashes and underscores (no spaces).": "Usernames can only use letters, digits, dots, dashes and underscores (no spaces).",
  "V": "V",
  "Valid": "Valid",
  "Validate and preview": "Validate and preview",
  "Validate package": "Validate package",
  "Validate the audio": "Validate the audio",
  "Validated definitions are importable. Review gameplay on your own maps before relying on balance.": "Validated definitions are importable. Review gameplay on your own maps before relying on balance.",
  "Validation did not pass": "Validation did not pass",
  "Validation was interrupted. Your AI has not been published.": "Validation was interrupted. Your AI has not been published.",
  "Value": "Value",
  "Variation": "Variation",
  "Verification": "Verification",
  "Verification ": "Verification ",
  "Verification and connection details": "Verification and connection details",
  "Verification failed": "Verification failed",
  "Verified": "Verified",
  "Version": "Version",
  "Version history": "Version history",
  "Version label": "Version label",
  "Version {slot0}": "Version {slot0}",
  "Version {value0}": "Version {value0}",
  "Version {value0}{value1}": "Version {value0}{value1}",
  "Versions": "Versions",
  "Versions of {slot0}": "Versions of {slot0}",
  "Versions of {value0}": "Versions of {value0}",
  "View orientation": "View orientation",
  "View profile and games": "View profile and games",
  "View reported paint": "View reported paint",
  "View revision": "View revision",
  "View {slot0}": "View {slot0}",
  "Viewing a saved revision. Restore it to make it the current draft.": "Viewing a saved revision. Restore it to make it the current draft.",
  "Viewing {slot0}": "Viewing {slot0}",
  "View…": "View…",
  "Visibility": "Visibility",
  "Volume": "Volume",
  "V{slot0} · {slot1}": "V{slot0} · {slot1}",
  "Wait for a pending compatibility check.": "Wait for a pending compatibility check.",
  "Wait for a pending generator check.": "Wait for a pending generator check.",
  "Wait for the provider call to return before cancelling.": "Wait for the provider call to return before cancelling.",
  "Waiting": "Waiting",
  "Waiting for service capacity. Your place is saved.": "Waiting for service capacity. Your place is saved.",
  "Waived": "Waived",
  "Warning": "Warning",
  "Warrior attack": "Warrior attack",
  "Warrior health": "Warrior health",
  "Warriors": "Warriors",
  "Warrush": "Warrush",
  "Watch AI play": "Watch AI play",
  "Watch in browser": "Watch in browser",
  "Watch your AI against a built-in opponent on the fixed test map. The game runs on this computer and ends when you close it.": "Watch your AI against a built-in opponent on the fixed test map. The game runs on this computer and ends when you close it.",
  "Water": "Water",
  "Waves": "Waves",
  "Webhook mode mismatch.": "Webhook mode mismatch.",
  "Weight": "Weight",
  "Welcome to the colony": "Welcome to the colony",
  "Welcome, {value0}": "Welcome, {value0}",
  "What changed": "What changed",
  "What will your world look like?": "What will your world look like?",
  "What would you like to create?": "What would you like to create?",
  "Whole model": "Whole model",
  "Why hide this map? (shown to its owner)": "Why hide this map? (shown to its owner)",
  "Wide": "Wide",
  "Width": "Width",
  "Win rate": "Win rate",
  "Win rate {slot0}": "Win rate {slot0}",
  "Win rate, {slot0} day": {
    "one": "Win rate, {slot0} day",
    "other": "Win rate, {slot0} days"
  },
  "Win rate, {slot0} days": "Win rate, {slot0} days",
  "Winner": "Winner",
  "Withdraw from library": "Withdraw from library",
  "Withdraw published family": "Withdraw published family",
  "Withdraw release": "Withdraw release",
  "Withdrawn": "Withdrawn",
  "Won": "Won",
  "Worker leases": "Worker leases",
  "Worker slots": "Worker slots",
  "Workers": "Workers",
  "Working…": "Working…",
  "Workspace view": "Workspace view",
  "Wrong username or password.": "Wrong username or password.",
  "YOUR COLONY": "YOUR COLONY",
  "YOUR COMPOSER": "YOUR COMPOSER",
  "Yes": "Yes",
  "Yes, continue": "Yes, continue",
  "You": "You",
  "You already own this product.": "You already own this product.",
  "You already reported this map.": "You already reported this map.",
  "You are already in a queue.": "You are already in a queue.",
  "You are muted.": "You are muted.",
  "You are not in this room.": "You are not in this room.",
  "You are sending messages too quickly.": "You are sending messages too quickly.",
  "You are signed in": "You are signed in",
  "You are signed in as": "You are signed in as",
  "You are signed out everywhere. Your name is gone from your past matches, which now show “Deleted player”. Thanks for playing.": "You are signed out everywhere. Your name is gone from your past matches, which now show “Deleted player”. Thanks for playing.",
  "You can close this page.": "You can close this page.",
  "You can only ban accounts with a lower role.": "You can only ban accounts with a lower role.",
  "You can only delete accounts with a lower role.": "You can only delete accounts with a lower role.",
  "You can only mute accounts with a lower role.": "You can only mute accounts with a lower role.",
  "You can send a new message to try again.": "You can send a new message to try again.",
  "You cannot ban yourself.": "You cannot ban yourself.",
  "You cannot change your own role.": "You cannot change your own role.",
  "You cannot delete your own account here.": "You cannot delete your own account here.",
  "You declined a match; wait before queueing again.": "You declined a match; wait before queueing again.",
  "You did not play in that match.": "You did not play in that match.",
  "You have no seat in a running match with that id.": "You have no seat in a running match with that id.",
  "You have not shared any maps yet.": "You have not shared any maps yet.",
  "Your account": "Your account",
  "Your account cannot host rooms.": "Your account cannot host rooms.",
  "Your account cannot join rooms.": "Your account cannot join rooms.",
  "Your account cannot play.": "Your account cannot play.",
  "Your account could not be refreshed. Please try again shortly.": "Your account could not be refreshed. Please try again shortly.",
  "Your account draft changed. Save your work on this device, then restore the account draft before saving again.": "Your account draft changed. Save your work on this device, then restore the account draft before saving again.",
  "Your account is now linked": "Your account is now linked",
  "Your account was deleted": "Your account was deleted",
  "Your browser could not prepare this photo.": "Your browser could not prepare this photo.",
  "Your building": "Your building",
  "Your building drafts": "Your building drafts",
  "Your building references are limited to 64 MiB. Delete old project history before uploading more.": "Your building references are limited to 64 MiB. Delete old project history before uploading more.",
  "Your building workspace is full.": "Your building workspace is full.",
  "Your building workspace is limited to 64 MiB. Export and delete an old draft first.": "Your building workspace is limited to 64 MiB. Export and delete an old draft first.",
  "Your changes were saved as a new skin.": "Your changes were saved as a new skin.",
  "Your collection has 100 designs. Delete an unused design to make room.": "Your collection has 100 designs. Delete an unused design to make room.",
  "Your colony has a sound.": "Your colony has a sound.",
  "Your creation will appear here. You can inspect, edit, compare, and publish saved versions.": "Your creation will appear here. You can inspect, edit, compare, and publish saved versions.",
  "Your credit is reserved while the provider outcome is reconciled.": "Your credit is reserved while the provider outcome is reconciled.",
  "Your credit remains reserved while the provider outcome is reconciled.": "Your credit remains reserved while the provider outcome is reconciled.",
  "Your credits are ready. Let’s create.": "Your credits are ready. Let’s create.",
  "Your drafts": "Your drafts",
  "Your first AI belongs here.": "Your first AI belongs here.",
  "Your first design starts with New skin. Your work saves automatically.": "Your first design starts with New skin. Your work saves automatically.",
  "Your first idea": "Your first idea",
  "Your game keeps its current account. You can close this page.": "Your game keeps its current account. You can close this page.",
  "Your idea or next change": "Your idea or next change",
  "Your map is ready to play.": "Your map is ready to play.",
  "Your match is already starting.": "Your match is already starting.",
  "Your next colony starts here. Play in your browser or join your friends.": "Your next colony starts here. Play in your browser or join your friends.",
  "Your next great map": "Your next great map",
  "Your next soundtrack": "Your next soundtrack",
  "Your next world starts with an idea.": "Your next world starts with an idea.",
  "Your profile": "Your profile",
  "Your projects will be saved here.": "Your projects will be saved here.",
  "Your purchases": "Your purchases",
  "Your saved building remains available in Building Studio.": "Your saved building remains available in Building Studio.",
  "Your set": "Your set",
  "Your swarm, in the game": "Your swarm, in the game",
  "Your terrain": "Your terrain",
  "Your uploaded photo": "Your uploaded photo",
  "Your workspace has 100 drafts. Delete an old draft first.": "Your workspace has 100 drafts. Delete an old draft first.",
  "Your world is taking shape…": "Your world is taking shape…",
  "You’re invited": "You’re invited",
  "Zoom": "Zoom",
  "Zoom in": "Zoom in",
  "Zoom in (+)": "Zoom in (+)",
  "Zoom out": "Zoom out",
  "Zoom out (−)": "Zoom out (−)",
  "a few seconds left": "a few seconds left",
  "aborted": "aborted",
  "about {minutes} min left": "about {minutes} min left",
  "about {seconds} s left": "about {seconds} s left",
  "account export": "account export",
  "and use this link again.": "and use this link again.",
  "as a guest, and sign in later to keep your games and rating.": "as a guest, and sign in later to keep your games and rating.",
  "b-": "b-",
  "banned": "banned",
  "browser sign-in completed": "browser sign-in completed",
  "browser sign-in completed from web session": "browser sign-in completed from web session",
  "build": "build",
  "building library": "building library",
  "by ": "by ",
  "by {slot0} · updated {slot1}": "by {slot0} · updated {slot1}",
  "by {slot0}{slot1}": "by {slot0}{slot1}",
  "cancelled": "cancelled",
  "check needs": "check needs",
  "checking…": "checking…",
  "checks need": "checks need",
  "deletes your maps, likes, uploads and your rating’s place on the leaderboards.": "deletes your maps, likes, uploads and your rating’s place on the leaderboards.",
  "diverged": "diverged",
  "dropped": "dropped",
  "finding": "finding",
  "findings": "findings",
  "forest": "forest",
  "format must be map or save.": "format must be map or save.",
  "format {value0}, network {value1}": "format {value0}, network {value1}",
  "get the game": "get the game",
  "hidden": "hidden",
  "hidden by a moderator": "hidden by a moderator",
  "icon {value0}": "icon {value0}",
  "in a web browser": "in a web browser",
  "inspection": "inspection",
  "invalid": "invalid",
  "joined {slot0} · last seen {slot1} · {slot2}": "joined {slot0} · last seen {slot1} · {slot2}",
  "launch timeout": "launch timeout",
  "limit must be an integer from 1 to {p0}.": "limit must be an integer from 1 to {p0}.",
  "live": "live",
  "madeWith must be hand or generator.": "madeWith must be hand or generator.",
  "map": "map",
  "match on now": "match on now",
  "match today": "match today",
  "matchId differs from the path.": "matchId differs from the path.",
  "matches on now": "matches on now",
  "matches today": "matches today",
  "median length": "median length",
  "muted until {slot0}": "muted until {slot0}",
  "none": "none",
  "not checked": "not checked",
  "not set": "not set",
  "on a computer": "on a computer",
  "on an Android device": "on an Android device",
  "on an iPhone or iPad": "on an iPhone or iPad",
  "owner must be \"me\" or an account id.": "owner must be \"me\" or an account id.",
  "package:": "package:",
  "participants must be all, humans or ai.": "participants must be all, humans or ai.",
  "payment": "payment",
  "play in your browser": "play in your browser",
  "player online": "player online",
  "players online": "players online",
  "projection": "projection",
  "provider sign-in failed": "provider sign-in failed",
  "provider unavailable": "provider unavailable",
  "provisional": "provisional",
  "provisional must be include or exclude.": "provisional must be include or exclude.",
  "public, max-age=604800": "public, max-age=604800",
  "record.sha256 differs from the uploaded record.": "record.sha256 differs from the uploaded record.",
  "refund": "refund",
  "removed from end": "removed from end",
  "replaces your name with “Deleted player” in your past matches, chat and records;": "replaces your name with “Deleted player” in your past matches, chat and records;",
  "resynced": "resynced",
  "right away, or": "right away, or",
  "r{slot0} · {slot1}": "r{slot0} · {slot1}",
  "signs you out on every device and removes your sign-in methods and e-mail address;": "signs you out on every device and removes your sign-in methods and e-mail address;",
  "silence added at end": "silence added at end",
  "simVersion (a sim version key) is required.": "simVersion (a sim version key) is required.",
  "simVersion differs from the match setup.": "simVersion differs from the match setup.",
  "simVersion must be a sim version key.": "simVersion must be a sim version key.",
  "size unknown": "size unknown",
  "sort must be one of {p0}.": "sort must be one of {p0}.",
  "starting": "starting",
  "status must be open, resolved, dismissed or all.": "status must be open, resolved, dismissed or all.",
  "teams must list the map's {p0} teams in order 0..{p1}.": "teams must list the map's {p0} teams in order 0..{p1}.",
  "text/html; charset=utf-8": "text/html; charset=utf-8",
  "today {time}": "today {time}",
  "unexpected instance response: {value0}": "unexpected instance response: {value0}",
  "unverifiable": "unverifiable",
  "valid": "valid",
  "v{slot0}": "v{slot0}",
  "world {value0}": "world {value0}",
  "{hours} {minutes}": "{hours} {minutes}",
  "{loaded} of {total} MB": "{loaded} of {total} MB",
  "{p0} No app?": "{p0} No app?",
  "{p0} Studio is not enabled on this instance.": "{p0} Studio is not enabled on this instance.",
  "{p0} as": "{p0} as",
  "{p0} invited you to their Globulation 2 room{p1}.": "{p0} invited you to their Globulation 2 room{p1}.",
  "{p0} must be an integer from {p1} to {p2}.": "{p0} must be an integer from {p1} to {p2}.",
  "{p0} sign-in is unavailable right now.": "{p0} sign-in is unavailable right now.",
  "{p0}’s room has closed, so this invite no longer works. Ask them for a new link, or start a game of your own.": "{p0}’s room has closed, so this invite no longer works. Ask them for a new link, or start a game of your own.",
  "{slot0}  {slot1} credit available": {
    "one": "{slot0}  {slot1} credit available",
    "other": "{slot0}  {slot1} credits available"
  },
  "{slot0}  {slot1} credits available": "{slot0}  {slot1} credits available",
  "{slot0} ({slot1}%)": "{slot0} ({slot1}%)",
  "{slot0} ({slot1})": "{slot0} ({slot1})",
  "{slot0} / {slot1}": "{slot0} / {slot1}",
  "{slot0} / {slot1} passed": "{slot0} / {slot1} passed",
  "{slot0} Manual editing and local playtests use no credits.": "{slot0} Manual editing and local playtests use no credits.",
  "{slot0} The preview shows exactly what will be saved.": "{slot0} The preview shows exactly what will be saved.",
  "{slot0} Try again, or download the set to listen locally.": "{slot0} Try again, or download the set to listen locally.",
  "{slot0} W · {slot1} L": "{slot0} W · {slot1} L",
  "{slot0} W · {slot1} L{slot2}": "{slot0} W · {slot1} L{slot2}",
  "{slot0} and resolve": "{slot0} and resolve",
  "{slot0} available · {slot1} reserved. Discussion requires an available credit; each delivered map or revision costs 1 credit. Failed generations return the credit.": "{slot0} available · {slot1} reserved. Discussion requires an available credit; each delivered map or revision costs 1 credit. Failed generations return the credit.",
  "{slot0} available · {slot1} reserved. Discussion requires an available credit; each delivered set or revision costs 1 credit. Failed generations return the credit.": "{slot0} available · {slot1} reserved. Discussion requires an available credit; each delivered set or revision costs 1 credit. Failed generations return the credit.",
  "{slot0} before buying so you can recover your purchases.": "{slot0} before buying so you can recover your purchases.",
  "{slot0} credit available": {
    "one": "{slot0} credit available",
    "other": "{slot0} credits available"
  },
  "{slot0} credit available · {slot1} reserved": {
    "one": "{slot0} credit available · {slot1} reserved",
    "other": "{slot0} credits available · {slot1} reserved"
  },
  "{slot0} credit reserved for work in progress.": {
    "one": "{slot0} credit reserved for work in progress.",
    "other": "{slot0} credits reserved for work in progress."
  },
  "{slot0} credit · {slot1}  {slot2}": {
    "one": "{slot0} credit · {slot1}  {slot2}",
    "other": "{slot0} credits · {slot1}  {slot2}"
  },
  "{slot0} credit — {slot1}": {
    "one": "{slot0} credit — {slot1}",
    "other": "{slot0} credits — {slot1}"
  },
  "{slot0} credits available": "{slot0} credits available",
  "{slot0} credits available · {slot1} reserved": "{slot0} credits available · {slot1} reserved",
  "{slot0} credits reserved for work in progress.": "{slot0} credits reserved for work in progress.",
  "{slot0} credits · {slot1}  {slot2}": "{slot0} credits · {slot1}  {slot2}",
  "{slot0} credits — {slot1}": "{slot0} credits — {slot1}",
  "{slot0} day": {
    "one": "{slot0} day",
    "other": "{slot0} days"
  },
  "{slot0} days": "{slot0} days",
  "{slot0} likes · {slot1} downloads": "{slot0} likes · {slot1} downloads",
  "{slot0} likes · {slot1} downloads · {slot2}": "{slot0} likes · {slot1} downloads · {slot2}",
  "{slot0} live · {slot1} in the last 24 hours": "{slot0} live · {slot1} in the last 24 hours",
  "{slot0} loop": "{slot0} loop",
  "{slot0} open reports · {slot1} uncertain requests · {slot2} failed engine jobs": "{slot0} open reports · {slot1} uncertain requests · {slot2} failed engine jobs",
  "{slot0} or inspect the reported library item’s validation.": "{slot0} or inspect the reported library item’s validation.",
  "{slot0} passed · {slot1}  {slot2}{slot3}": "{slot0} passed · {slot1}  {slot2}{slot3}",
  "{slot0} properties": "{slot0} properties",
  "{slot0} reserved. Credits belong to this studio.": "{slot0} reserved. Credits belong to this studio.",
  "{slot0} selected · up to 10 sets, 64 MiB": "{slot0} selected · up to 10 sets, 64 MiB",
  "{slot0} teams": "{slot0} teams",
  "{slot0} terrain · {slot1} resources · revision {slot2}": {
    "one": "{slot0} terrain · {slot1} resources · revision {slot2}",
    "other": "{slot0} terrains · {slot1} resources · revision {slot2}"
  },
  "{slot0} terrain · {slot1} resources · {slot2}": {
    "one": "{slot0} terrain · {slot1} resources · {slot2}",
    "other": "{slot0} terrains · {slot1} resources · {slot2}"
  },
  "{slot0} terrains · {slot1} resources · revision {slot2}": "{slot0} terrains · {slot1} resources · revision {slot2}",
  "{slot0} terrains · {slot1} resources · {slot2}": "{slot0} terrains · {slot1} resources · {slot2}",
  "{slot0} tiles": "{slot0} tiles",
  "{slot0} to create and save drafts.": "{slot0} to create and save drafts.",
  "{slot0} to publish.": "{slot0} to publish.",
  "{slot0} to see and share your maps.": "{slot0} to see and share your maps.",
  "{slot0} to see your generators.": "{slot0} to see your generators.",
  "{slot0} to see your library.": "{slot0} to see your library.",
  "{slot0} to share an AI.": "{slot0} to share an AI.",
  "{slot0} to share maps.": "{slot0} to share maps.",
  "{slot0} today · {slot1} in 7 days · {slot2} in 30 days": "{slot0} today · {slot1} in 7 days · {slot2} in 30 days",
  "{slot0} unique accounts · previous period {slot1}": "{slot0} unique accounts · previous period {slot1}",
  "{slot0} with a moderator account.": "{slot0} with a moderator account.",
  "{slot0} within {slot1} minutes": "{slot0} within {slot1} minutes",
  "{slot0} {slot1} · AI composition is disclosed.": "{slot0} {slot1} · AI composition is disclosed.",
  "{slot0} · Continue editing": "{slot0} · Continue editing",
  "{slot0} · Custom artwork and gameplay properties": "{slot0} · Custom artwork and gameplay properties",
  "{slot0} · based on revision {slot1}": "{slot0} · based on revision {slot1}",
  "{slot0} · last seen {slot1}{slot2}": "{slot0} · last seen {slot1}{slot2}",
  "{slot0} · per million tokens: {slot1} input / {slot2} cached / {slot3} output credits.": "{slot0} · per million tokens: {slot1} input / {slot2} cached / {slot3} output credits.",
  "{slot0} · playing since {slot1}{slot2}": "{slot0} · playing since {slot1}{slot2}",
  "{slot0} · revision {slot1}": "{slot0} · revision {slot1}",
  "{slot0} · revision {slot1} · {slot2}": "{slot0} · revision {slot1} · {slot2}",
  "{slot0} · saved generation preview": "{slot0} · saved generation preview",
  "{slot0} · seed {slot1} · {slot2}": "{slot0} · seed {slot1} · {slot2}",
  "{slot0} · seed {slot1} · {slot2}{slot3}": "{slot0} · seed {slot1} · {slot2}{slot3}",
  "{slot0} · {slot1}": "{slot0} · {slot1}",
  "{slot0} · {slot1} MiB stored": "{slot0} · {slot1} MiB stored",
  "{slot0} · {slot1} likes": "{slot0} · {slot1} likes",
  "{slot0} · {slot1} second": {
    "one": "{slot0} · {slot1} second",
    "other": "{slot0} · {slot1} seconds"
  },
  "{slot0} · {slot1} seconds": "{slot0} · {slot1} seconds",
  "{slot0} · {slot1} since {slot2}": "{slot0} · {slot1} since {slot2}",
  "{slot0} · {slot1} {slot2}": "{slot0} · {slot1} {slot2}",
  "{slot0} · {slot1} · last renewed {slot2}{slot3}": "{slot0} · {slot1} · last renewed {slot2}{slot3}",
  "{slot0} · {slot1} · {slot2}": "{slot0} · {slot1} · {slot2}",
  "{slot0} · {slot1} · {slot2} downloads": "{slot0} · {slot1} · {slot2} downloads",
  "{slot0} · {slot1} · {slot2} × {slot3}": "{slot0} · {slot1} · {slot2} × {slot3}",
  "{slot0} · {slot1} · {slot2}{slot3}": "{slot0} · {slot1} · {slot2}{slot3}",
  "{slot0} · {slot1}{slot2}": "{slot0} · {slot1}{slot2}",
  "{slot0} · {slot1}×{slot2}": "{slot0} · {slot1}×{slot2}",
  "{slot0} × {slot1}  {slot2} UNCHARTED TERRITORY": "{slot0} × {slot1}  {slot2} UNCHARTED TERRITORY",
  "{slot0} × {slot1} · {slot2} player": {
    "one": "{slot0} × {slot1} · {slot2} player",
    "other": "{slot0} × {slot1} · {slot2} players"
  },
  "{slot0} × {slot1} · {slot2} player · Private until published": {
    "one": "{slot0} × {slot1} · {slot2} player · Private until published",
    "other": "{slot0} × {slot1} · {slot2} players · Private until published"
  },
  "{slot0} × {slot1} · {slot2} players": "{slot0} × {slot1} · {slot2} players",
  "{slot0} × {slot1} · {slot2} players · Private until published": "{slot0} × {slot1} · {slot2} players · Private until published",
  "{slot0} ↗": "{slot0} ↗",
  "{slot0}%": "{slot0}%",
  "{slot0}/32": "{slot0}/32",
  "{slot0}: collected {slot1} · refunded {slot2} · collected less refunds {slot3}": "{slot0}: collected {slot1} · refunded {slot2} · collected less refunds {slot3}",
  "{slot0}: default {slot1}{slot2}": "{slot0}: default {slot1}{slot2}",
  "{slot0}: since {slot1}{slot2}": "{slot0}: since {slot1}{slot2}",
  "{slot0}: starts at {slot1}, holds {slot2}; {slot3}": "{slot0}: starts at {slot1}, holds {slot2}; {slot3}",
  "{slot0}: {slot1}": "{slot0}: {slot1}",
  "{slot0}: {slot1} · {slot2}": "{slot0}: {slot1} · {slot2}",
  "{slot0}: {slot1} · {slot2} credit": {
    "one": "{slot0}: {slot1} · {slot2} credit",
    "other": "{slot0}: {slot1} · {slot2} credits"
  },
  "{slot0}: {slot1} · {slot2} credits": "{slot0}: {slot1} · {slot2} credits",
  "{slot0}by {slot1} · ♥ {slot2}": "{slot0}by {slot1} · ♥ {slot2}",
  "{slot0}{slot1} · ♥ {slot2}{slot3}": "{slot0}{slot1} · ♥ {slot2}{slot3}",
  "{slot0}{slot1}% chat": "{slot0}{slot1}% chat",
  "{slot0}°": "{slot0}°",
  "{slot0}×{slot1}": "{slot0}×{slot1}",
  "{slot0}–{slot1}": "{slot0}–{slot1}",
  "{value0} (no preview)": "{value0} (no preview)",
  "{value0} Map credits": "{value0} Map credits",
  "{value0} Music credits": "{value0} Music credits",
  "{value0} Stripe minor units": "{value0} Stripe minor units",
  "{value0} artwork": "{value0} artwork",
  "{value0} conversation": "{value0} conversation",
  "{value0} cover": "{value0} cover",
  "{value0} credits": "{value0} credits",
  "{value0} hue": "{value0} hue",
  "{value0} rendered preview": "{value0} rendered preview",
  "{value0} saturation and brightness": "{value0} saturation and brightness",
  "{value0} swatches": "{value0} swatches",
  "{value0} terrain illustration": "{value0} terrain illustration",
  "{value0} waveform": "{value0} waveform",
  "{value0} {value1} · {value2} likes": "{value0} {value1} · {value2} likes",
  "{value0}, frame {value1}": "{value0}, frame {value1}",
  "{value0}, frame {value1}, team color layer": "{value0}, frame {value1}, team color layer",
  "{value0}, home": "{value0}, home",
  "{value0}. Change theme": "{value0}. Change theme",
  "{value0}: terrain and resource previews": "{value0}: terrain and resource previews",
  "{value0}: units in this match and on average over recent matches": "{value0}: units in this match and on average over recent matches",
  "{value0}vs {value1}": "{value0}vs {value1}",
  "×": "×",
  "–": "–",
  "•••": "•••",
  "…": "…",
  "← Music library": "← Music library",
  "← Set library": "← Set library",
  "← {slot0}": "← {slot0}",
  "← → saturation · ↑ ↓ brightness": "← → saturation · ↑ ↓ brightness",
  "↑": "↑",
  "→": "→",
  "↓ {slot0} downloads": "↓ {slot0} downloads",
  "↗": "↗",
  "↻ Continuous loop": "↻ Continuous loop",
  "−": "−",
  "⌄": "⌄",
  "◎": "◎",
  "●": "●",
  "★": "★",
  "♥ {slot0}": "♥ {slot0}",
  "♥ {slot0} likes": "♥ {slot0} likes",
  "♥ {slot0} · {slot1}": "♥ {slot0} · {slot1}",
  "✓ verified": "✓ verified",
  "✕": "✕",
  "✧ Map designer": "✧ Map designer",
  "⠿ {slot0}": "⠿ {slot0}",
  "＋": "＋",
  " (draw)": " (draw)",
  " (log₂ tiles)": " (log₂ tiles)",
  " (lost)": " (lost)",
  " (won)": " (won)",
  " ({value0}–{value1}, step {value2})": " ({value0}–{value1}, step {value2})",
  " Colony {value0}.": " Colony {value0}.",
  " Location: {value0}, {value1}.": " Location: {value0}, {value1}.",
  " properties": " properties",
  " · AI-generated": " · AI-generated",
  " · Changes not applied": " · Changes not applied",
  " · Used for your next match": " · Used for your next match",
  " · construction": " · construction",
  " · first at {value0}": " · first at {value0}",
  " · rated": " · rated",
  " · unrated": " · unrated",
  " · {count} recorded downloads": " · {count} recorded downloads",
  " · {count} team": {
    "one": " · {count} team",
    "other": " · {count} teams"
  },
  " · {count} teams": " · {count} teams",
  " · {value0} unresolved": " · {value0} unresolved",
  "(current)": "(current)",
  "(older version)": "(older version)",
  "A community-created colony controller.": "A community-created colony controller.",
  "AI Colony Studio": "AI Colony Studio",
  "AI coding conversation": "AI coding conversation",
  "Add islands and sheltered starting colonies…": "Add islands and sheltered starting colonies…",
  "Applied to the draft": "Applied to the draft",
  "Building designer": "Building designer",
  "COMPOSER": "COMPOSER",
  "CREATION IN PROGRESS": "CREATION IN PROGRESS",
  "Coding requests use up to {value0} {value1} credits. Manual editing and local playtests are free.": "Coding requests use up to {value0} {value1} credits. Manual editing and local playtests are free.",
  "Coding requests use up to {value0} {value1} credits. Source acceptance does not mean engine checks passed.": "Coding requests use up to {value0} {value1} credits. Source acceptance does not mean engine checks passed.",
  "Collapse sidebar": "Collapse sidebar",
  "Collapse toolbox": "Collapse toolbox",
  "Comparison with ": "Comparison with ",
  "Copy my library version": "Copy my library version",
  "Definition validation failed.": "Definition validation failed.",
  "Definition validation passed.": "Definition validation passed.",
  "Deleting…": "Deleting…",
  "Delivered to draft": "Delivered to draft",
  "Describe the landscape you have in mind. Watch its journey from first idea to a world you can play.": "Describe the landscape you have in mind. Watch its journey from first idea to a world you can play.",
  "Editing saved revision {value0}": "Editing saved revision {value0}",
  "Engine validation failed.": "Engine validation failed.",
  "Engine validation passed": "Engine validation passed",
  "Engine validation passed.": "Engine validation passed.",
  "Enter usage verified against provider evidence. Input totals include cache creation/write tokens. Unknown usage must not be entered as zero.": "Enter usage verified against provider evidence. Input totals include cache creation/write tokens. Unknown usage must not be entered as zero.",
  "Example of ": "Example of ",
  "Expand sidebar": "Expand sidebar",
  "Expand toolbox": "Expand toolbox",
  "Explore this step.": "Explore this step.",
  "Fix this": "Fix this",
  "Fixed-point units: 256 = 1, 128 = 0.5, 512 = 2.": "Fixed-point units: 256 = 1, 128 = 0.5, 512 = 2.",
  "Follow latest generation": "Follow latest generation",
  "Following latest generation": "Following latest generation",
  "Generation needs attention": "Generation needs attention",
  "Generator coding conversation": "Generator coding conversation",
  "Generator package": "Generator package",
  "Good under {value0}, fair under {value1}, poor from {value2}.": "Good under {value0}, fair under {value1}, poor from {value2}.",
  "IMAGINATION, MEET POSSIBILITY": "IMAGINATION, MEET POSSIBILITY",
  "Images appear here as this stage completes.": "Images appear here as this stage completes.",
  "Import .js": "Import .js",
  "Import JavaScript": "Import JavaScript",
  "Import generator package": "Import generator package",
  "Loading workspace…": "Loading workspace…",
  "Make my colony more defensive…": "Make my colony more defensive…",
  "Mute": "Mute",
  "No": "No",
  "No account needed for rooms and casual games; sign in to be ranked.": "No account needed for rooms and casual games; sign in to be ranked.",
  "No additional details were recorded.": "No additional details were recorded.",
  "No release notes.": "No release notes.",
  "One JavaScript file.": "One JavaScript file.",
  "One manifest and one JavaScript module.": "One manifest and one JavaScript module.",
  "Pause animation": "Pause animation",
  "Play animation": "Play animation",
  "Play music": "Play music",
  "Playtest": "Playtest",
  "Preparing your soundtrack…": "Preparing your soundtrack…",
  "Publish to music library": "Publish to music library",
  "Publishing…": "Publishing…",
  "Refine your soundtrack": "Refine your soundtrack",
  "Replace generator package": "Replace generator package",
  "Replace source with JavaScript file": "Replace source with JavaScript file",
  "Retry saved request": "Retry saved request",
  "Review the technical results for this finding.": "Review the technical results for this finding.",
  "Run current revision": "Run current revision",
  "Saved candidate": "Saved candidate",
  "Saved privately. Publishing shares only this version.": "Saved privately. Publishing shares only this version.",
  "Saving…": "Saving…",
  "Send": "Send",
  "Send diagnostics to chat": "Send diagnostics to chat",
  "Sign in with a registered account to like music": "Sign in with a registered account to like music",
  "Signed HP per exposed tick, divided by 256; negative values damage units.": "Signed HP per exposed tick, divided by 256; negative values damage units.",
  "Something wonderful is taking shape.": "Something wonderful is taking shape.",
  "Start live game": "Start live game",
  "Start with a feeling": "Start with a feeling",
  "Terrain designer": "Terrain designer",
  "The assistant edits your file. You decide when to test.": "The assistant edits your file. You decide when to test.",
  "The assistant edits your manifest and JavaScript together. You decide when to generate or run checks.": "The assistant edits your manifest and JavaScript together. You decide when to generate or run checks.",
  "The provider outcome needs reconciliation. No duplicate call will be sent.": "The provider outcome needs reconciliation. No duplicate call will be sent.",
  "The provider outcome needs reconciliation. Your credit remains reserved.": "The provider outcome needs reconciliation. Your credit remains reserved.",
  "The provider outcome needs reconciliation. Your reserved {value0} credits remain held; new requests are paused. Manual editing and export remain available.": "The provider outcome needs reconciliation. Your reserved {value0} credits remain held; new requests are paused. Manual editing and export remain available.",
  "This match": "This match",
  "This request is paused while its result is checked. Your reserved credit stays safe; you can leave and return later.": "This request is paused while its result is checked. Your reserved credit stays safe; you can leave and return later.",
  "This version is public.": "This version is public.",
  "Try “a winding river with fertile banks” or ask how the current generator works.": "Try “a winding river with fertile banks” or ask how the current generator works.",
  "Try “focus on food before expansion” or ask how the current code works.": "Try “focus on food before expansion” or ask how the current code works.",
  "Use working starter": "Use working starter",
  "VIEW": "VIEW",
  "Validation failed": "Validation failed",
  "We could not finish this map. Your earlier maps are safe.": "We could not finish this map. Your earlier maps are safe.",
  "What kind of colony will you build?": "What kind of colony will you build?",
  "What landscape will you create?": "What landscape will you create?",
  "Working on your request…": "Working on your request…",
  "YOU": "YOU",
  "Your colony AI": "Your colony AI",
  "Your colony’s soundtrack, in three moods.": "Your colony’s soundtrack, in three moods.",
  "Your composer is working…": "Your composer is working…",
  "Your landscape": "Your landscape",
  "Your message could not be completed.": "Your message could not be completed.",
  "Your music takes shape here": "Your music takes shape here",
  "Your next battlefield starts here.": "Your next battlefield starts here.",
  "Your projects": "Your projects",
  "generated": "generated",
  "hand-made": "hand-made",
  "no sign-in methods": "no sign-in methods",
  "one unit per harvest": "one unit per harvest",
  "stock remains available after harvesting": "stock remains available after harvesting",
  "the whole stock per harvest": "the whole stock per harvest",
  "usage pending": "usage pending",
  "with {value0} ": "with {value0} ",
  "{count} credit": {
    "one": "{count} credit",
    "other": "{count} credits"
  },
  "{count} credits": "{count} credits",
  "{count} player on this page": {
    "one": "{count} player on this page",
    "other": "{count} players on this page"
  },
  "{count} players on this page": "{count} players on this page",
  "{count} team · ": {
    "one": "{count} team · ",
    "other": "{count} teams · "
  },
  "{count} teams · ": "{count} teams · ",
  "{count} version": {
    "one": "{count} version",
    "other": "{count} versions"
  },
  "{count} versions": "{count} versions",
  "{count} {status}": "{count} {status}",
  "{slot0} · {count} image": {
    "one": "{slot0} · {count} image",
    "other": "{slot0} · {count} images"
  },
  "{slot0} · {count} images": "{slot0} · {count} images",
  "{value0} HP per exposed tick": "{value0} HP per exposed tick",
  "{value0} Your credit was returned.": "{value0} Your credit was returned.",
  "{value0} copy": "{value0} copy",
  "{value0} not found": "{value0} not found",
  "{value0} playing": "{value0} playing",
  "{value0} request needs attention in Preview.": "{value0} request needs attention in Preview.",
  "{value0} response ready in Preview.": "{value0} response ready in Preview.",
  "{value0} seconds": "{value0} seconds",
  "{value0} selected": "{value0} selected",
  "{value0} {value1} attention": "{value0} {value1} attention",
  "{value0} · revision {value1}": "{value0} · revision {value1}",
  "{value0} × {value1} preview pixels": "{value0} × {value1} preview pixels",
  "{value0} × {value1} · {value2} players": "{value0} × {value1} · {value2} players",
  "{value0}% saturation, {value1}% brightness": "{value0}% saturation, {value1}% brightness",
  "{value0}: {count} open": "{value0}: {count} open",
  "{value0}: {count} searching": "{value0}: {count} searching",
  "{value0}× wheat": "{value0}× wheat",
  "{value0}’s average": "{value0}’s average",
  "× Compatibility checks failed": "× Compatibility checks failed",
  "▶ Let the globs roam": "▶ Let the globs roam",
  "★ Favourited": "★ Favourited",
  "☆ Favourite": "☆ Favourite",
  "♡ Like": "♡ Like",
  "♥ Liked": "♥ Liked",
  "✓ Passed compatibility checks": "✓ Passed compatibility checks",
  "✓ uploaded": "✓ uploaded",
  "❚❚ Pause the globs": "❚❚ Pause the globs",
  "Converted terrain": "Converted terrain",
  "Native terrain preview · awaiting checks": "Native terrain preview · awaiting checks",
  "Generated layout · intermediate image": "Generated layout · intermediate image",
  "Selected map area": "Selected map area",
  "Cropped layout · intermediate image": "Cropped layout · intermediate image",
  "Landscape reference {count}": "Landscape reference {count}",
  "Composition source · edit {count}": "Composition source · edit {count}",
  "Candidate {count} execution report": "Candidate {count} execution report",
  "Candidate {count} score": "Candidate {count} score",
  "Candidate {count} · validated": "Candidate {count} · validated",
  "Candidate {count} · needs repairs": "Candidate {count} · needs repairs",
  "Candidate {count} report": "Candidate {count} report",
  "Validation report": "Validation report",
  "Game-rendered scene and resource gallery": "Game-rendered scene and resource gallery",
  "Native validation report": "Native validation report",
  "Engine import and artwork": "Engine import and artwork",
  "Engine definitions and artwork": "Engine definitions and artwork",
  "Requested size and players": "Requested size and players",
  "Valid colony starts": "Valid colony starts",
  "Resource growth enabled": "Resource growth enabled",
  "Connected walking routes": "Connected walking routes",
  "Opening economy measured": "Opening economy measured",
  "Colony {count}: building space": "Colony {count}: building space",
  "Colony {count}: starter food": "Colony {count}: starter food",
  "Colony {count}: starter timber": "Colony {count}: starter timber",
  "Colony {count}: renewable food ground": "Colony {count}: renewable food ground",
  "Properties": "Properties",
  "Semantics": "Semantics",
  "Presentation": "Presentation",
  "{value0} source": "{value0} source",
  "{value0} decor source": "{value0} decor source",
  "Your draft changed while the design was loading. Your changes were kept; try opening the design again.": "Your draft changed while the design was loading. Your changes were kept; try opening the design again.",
  "More filters": "More filters",
  "Clear filters": "Clear filters",
  "No results match these filters.": "No results match these filters.",
  "Results: {value0}": "Results: {value0}"
}
